import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import {
	checkLocalSavedData,
	handleGameProgressUpdate,
	displayTooltip,
	destroyInstructions,
	destroyTooltip,
	destroyIndicator,
	displayTutorialHand,
	destroyTutorialHand,
	animateElements,
	playNotificationAnimation,
	removeNotificationBell,
	playConfettiAnimation,
	playTickAnimation,
	playFireworksAnimation,
	destroyFireworksAnimation
} from "../helpers/levelManager"
import { displayIndicator } from "../helpers/levelManager"
import { displayInstructions } from "../helpers/levelManager"
import { updateMiniLevel } from "../helpers/levelManager"
import {
	saveCreatureStatusLocally,
	createStoryPanel,
	playUISound,
} from "../helpers/levelManager"

import { MediclinicAPI } from "../helpers/apiHandler"

import { showFeedingTray } from "../helpers/cockpitFunctions/showFeedingTrayFunction"
import { feedingFunctionality } from "../helpers/cockpitFunctions/feedingFunctionalityFunction"

import { htmlOverlay, phaserOverlay } from "../helpers/planetBlocker"

export default class CockpitScene extends Phaser.Scene {
	constructor() {
		super({ key: "CockpitScene" })
		this.currentPage = 0
		this.totalPages = 4
		this.canClickBool = true
	}

	init() {
		this.initializeGameDimensions()
		this.loadSavedData()
		this.fetchCreatureBool = false
		this.creature3Bool = false

		this.apiHandler = new MediclinicAPI()

		this.tutorialComplete = false
		this.tutorialStep = 0
		this.planet2Creature3ScaledIn = false
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager
		this.soundManager.playMusic("Muzac_bad_speaker", { volume: 0.2 })

		this.setupScene()
		this.createAnimations()
		this.createGameElements()
		this.initializeBasedOnLevel()

		this.launchButton = this.add
			.sprite(this.gameW / 2, this.gameH / 2, "launchBtn")
			.setScale(this.scaleFactor * 0.5)
			.setInteractive()

		// this.launchButtonText = this.add
		// 	.text(
		// 		this.launchButton.x,
		// 		this.launchButton.y - 8 * this.scaleFactor,
		// 		"LAUNCH",
		// 		{
		// 			fontFamily: "Gluten",
		// 			fontSize: 20 + 2 * this.scaleFactor,
		// 			color: "#fff",
		// 			fontWeight: "700",
		// 			fontStyle: "bold",
		// 			align: "left",
		// 			resolution: 2,
		// 		},
		// 	)
		// 	.setOrigin(0.5, 0.5)

		this.launchButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.pauseAllSounds()

			this.cameras.main.fadeOut(500, 0, 0, 0)
			this.cameras.main.once("camerafadeoutcomplete", () => {
				this.scene.start("MissionOutro")
				this.scene.stop("CockpitScene")
			})
		})

		this.launchButton.setVisible(false)

		// if (this.currentPlanet == 1) {
		// 	htmlOverlay(this)
		// }
		// this.launchButtonText.setVisible(false)
	}

	// ---- INITIALIZATION METHODS ----

	initializeGameDimensions() {
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight

		// Define common scales
		this.scaleUpButtonScale = this.scaleFactor * 1
		this.tabletButtonScale = this.scaleFactor / 2.5
		this.tabletNotifScale = this.scaleFactor
		this.screenWidth = this.gameW // Width of each screen section
		this.moveDistance = this.screenWidth // Movement distance per navigation

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor
	}

	loadSavedData() {
		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedOrnament = this.savedUserData?.customization?.ornament || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 1
		this.alertsOpened = this.savedUserData?.alertsOpened || {}
		console.log("MiniLevel: " + this.savedMiniLevel)
	}

	setupScene() {
		this.cameras.main.fadeIn(500, 0, 0, 0)
	}

	createAnimations() {
		this.anims.create({
			key: "creature_scan",
			frames: this.anims.generateFrameNames("creatureScan", {
				start: 0,
				end: 60,
				zeroPad: 4,
				prefix: "scan_",
				suffix: ".png",
			}),
			frameRate: 15,
			//repeat: -1
		})
	}

	// ---- MAIN CREATION METHODS ----

	createGameElements() {
		this.createBackgrounds()
		this.createCockpit()
	}

	createBackgrounds() {
		this.add
			.image(
				this.gameW / 2,
				this.gameH / 2 - 50 * this.scaleFactor,
				"planet01Close",
			)
			.setScale(this.scaleFactor)
	}

	createCockpit() {
		// Create all cockpit components
		this.createFrontSide()
		this.createLeftSide()
		this.createBackSide()
		this.createRightSide()

		// Create container for main pages, including all sprites
		this.createCockpitContainer()

		// Create navigation and utility buttons
		this.createNavigationButtons()

		// Create scanner
		this.scan = this.add
			.sprite(this.gameW / 2, this.gameH / 2, "creatureScan", "scan_0000.png")
			.setScale(this.scaleFactor * 0.65, this.scaleFactor * 0.65)

		this.scan.setVisible(false)
	}

	// ---- COCKPIT SIDES CREATION ----

	createFrontSide() {
		// Front cockpit panel
		this.cockpitFront = this.add
			.image(
				this.gameW / 2,
				this.gameH / 2,
				"cockpitFront_" + this.currentPlanet,
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)

		// // Tablet interactive area
		// this.tablet = this.createInteractiveElement(
		//     this.gameW / 2 - 200 * this.scaleFactor,
		//     this.gameH / 2 - 20 * this.scaleFactor,
		//     'circle',
		//     this.scaleFactor / 2,
		//     0.5,
		//     () => {
		//         this.scene.launch('TabletScene');
		//         this.scene.launch('TabletUI');
		//         this.scene.pause('CockpitScene');
		//     }
		// );
		const fuelStates = {
			1: "fuelState5",
			2: "fuelState4",
			3: "fuelState3",
		}
		this.currentFuelState = fuelStates[this.currentPlanet]

		this.fuelGauge = this.add
			.image(
				this.gameW / 2 + 5 * this.scaleFactor,
				this.gameH / 2 - 37 * this.scaleFactor,
				this.currentFuelState,
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.3)

		// Radar interactive area
		this.radar = this.createInteractiveElement(
			this.gameW / 2 + 200 * this.scaleFactor,
			this.gameH / 2 - 20 * this.scaleFactor,
			"circle",
			this.scaleFactor / 2,
			0.5,
			() => {
				playUISound(this, this.soundManager, "Click-pop1", 0.55)
				if (this.tutorialHand) {
					this.tutorialHand.destroy()
				}
				destroyTooltip(this)
				destroyIndicator(this)
				this.scene.launch("RadarScene")
				this.scene.pause("CockpitScene")
			},
		)
			.setVisible(true)
			.setAlpha(0.05)

		const PLANET_PANELS = {
			1: "hypotheraPanel",
			2: "stratosomaPanel",
			3: "emberonPanel",
		}

		let planetName = PLANET_PANELS[this.currentPlanet] || ""

		this.planetNamePanel = this.add
			.image(
				this.radar.x,
				this.radar.y + 12 * this.scaleFactor,
				planetName,
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor / 2)
			.setVisible(false)

		// Decorative ornament
		this.ornament = this.add
			.image(
				this.gameW / 2 - 350 * this.scaleFactor,
				this.gameH / 2 - 50 * this.scaleFactor,
				"ornament0" + this.savedOrnament,
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor / 3)
	}

	createBackSide() {
		// Back view
		this.cockpitBack = this.add
			.image(this.gameW * 2.5, this.gameH / 2, "cockpitBack")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
	}

	createLeftSide() {
		// Left view
		const baseX = this.gameW * 1.5
		const baseY = this.gameH / 2
		let creatureImage
		let creatureTagImage
		if (this.savedUserData.currentPlanet === 1) {
			creatureImage = "creature01_hungry"
			this.currentLeftCreature = 1
			creatureTagImage = "frostStalkerTag"
		}
		if (this.savedUserData.currentPlanet === 2) {
			creatureImage = "creature03_hungry"
			creatureTagImage = "driftBackTag"
			//or creature05_hungry if 03 is already discharged
			this.currentLeftCreature = 3
			//or 5 if 3 is already discharged
		}
		if (this.savedUserData.currentPlanet === 3) {
			creatureImage = "creature06_hungry"
			creatureTagImage = "obsidianSnailTag"
			//or creature05_hungry if 07 is already discharged
			this.currentLeftCreature = 6
			//or 07 if 5 is already discharged
		}

		// Main tube structure
		this.leftSide = this.add
			.image(baseX, baseY, "tubeR_" + this.currentPlanet)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)

		this.leftSideZoomed = this.add
			.image(baseX, baseY, "rightZoomed" + this.currentPlanet)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)

		// Task panels - now passing only side and coordinates, we'll determine food types inside createTubeTaskPanels
		this.createTubeTaskPanels("left", baseX, baseY)

		// Tube and creature
		this.leftTubeBack = this.add
			.image(baseX, baseY, "tubeBack")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.8)

		this.creatureTubeL = this.add
			.image(baseX, baseY, creatureImage)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.25)

		if (this.currentPlanet === 1) {
			this.creatureTubeL.setScale(this.scaleFactor * 0.25)
			this.creatureTubeL.y += 20 * this.scaleFactor
		}

		if (this.currentPlanet === 2) {
			//Planet 2 Creature Offset
			this.originalCreatureLScale = this.creatureTubeL.scale
			this.creatureTubeL.y += 20 * this.scaleFactor
		}

		if (this.currentPlanet === 3) {
			this.creatureTubeL.setScale(this.scaleFactor * 0.25)
			if (creatureTagImage === "obsidianSnailTag") {
				this.creatureTubeL.y += 25 * this.scaleFactor
				this.originalTubeLYPos = this.creatureTubeL.y
			}
		}

		this.leftTubeFront = this.add
			.image(baseX, baseY, "tubeFront")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.8)

		this.leftTubeTag = this.add
			.image(baseX, baseY + 122 * this.scaleFactor, "tube1LabelSmall")
			.setOrigin(0.5)
			.setScale(this.scaleFactor)

		this.leftNameTag = this.add
			.image(
				baseX + 80 * this.scaleFactor,
				baseY - 50 * this.scaleFactor,
				creatureTagImage,
			)
			.setOrigin(1)
			.setScale(this.scaleFactor / 2)
			.setVisible(false)

		this.originalTagPosition = {
			x: baseX + 80 * this.scaleFactor,
			y: baseY - 50 * this.scaleFactor,
		}

		this.tubeTagOriginalPosition = {
			x: baseX,
			y: baseY + 122 * this.scaleFactor,
		}
		// Scale up button
		this.leftScaleUpButton = this.createInteractiveElement(
			//baseX + 300 * this.scaleFactor,
			baseX,
			this.gameH / 2 + 20 * this.scaleFactor,
			"scaleUpButtonNew",
			0,
			1,
			() => this.handleScaleUpClick("left"),
		)
	}

	// cockpitLeftZoomed() {
	//     const baseX = this.gameW * 1.5;
	//     const baseY = this.gameH / 2;

	//     this.leftSideZoomed = this.add.image(baseX, baseY, 'leftZoomed')
	//         .setOrigin(0.5)
	//         .setScale(this.scaleFactor);
	// }

	createRightSide() {
		// Right view
		const baseX = this.gameW * 3.5
		const baseY = this.gameH / 2
		let creatureImage
		let creatureTagImage
		if (this.savedUserData.currentPlanet === 1) {
			creatureImage = "creature02_hungry"
			creatureTagImage = "iceCrawlerTag"
			this.currentRightCreature = 2
		}
		if (this.savedUserData.currentPlanet === 2) {
			creatureImage = "creature04_hungry"
			creatureTagImage = "cloudStriderTag"
			//or creature06_hungry if 04 is already discharged
			this.currentRightCreature = 4
			//or 5 if 3 is already discharged
		}
		if (this.savedUserData.currentPlanet === 3) {
			creatureImage = "creature07_hungry"
			creatureTagImage = "blazeWraithTag"
			//or creature06_hungry if 08 is already discharged
			this.currentRightCreature = 7
			//or 8 if 6 is already discharged
		}

		// Main tube structure
		this.tubeR = this.add
			.image(baseX, baseY, "tubeL_" + this.currentPlanet)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)

		this.rightSideZoomed = this.add
			.image(baseX, baseY, "leftZoomed")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)

		// Task panels
		this.createTubeTaskPanels("right", baseX, baseY, "FoodType02")

		// Tube and creature
		this.rightTubeBack = this.add
			.image(baseX, baseY, "tubeBack")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.8)

		this.creatureTubeR = this.add
			.image(baseX, baseY, creatureImage)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.25)

		if (this.currentPlanet === 1) {
			this.creatureTubeR.setScale(this.scaleFactor * 0.25)
		}
		if (this.currentPlanet === 2) {
			this.creatureTubeR.y += 10 * this.scaleFactor
			this.creatureTubeR.setScale(this.scaleFactor * 0.25)
		}
		if (this.currentPlanet === 3) {
			this.creatureTubeR.setScale(this.scaleFactor * 0.25)
			this.creatureTubeR.y += 20 * this.scaleFactor
		}

		this.rightTubeFront = this.add
			.image(baseX, baseY, "tubeFront")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.8)

		this.rightTubeTag = this.add
			.image(baseX, baseY + 122 * this.scaleFactor, "tube2LabelSmall")
			.setOrigin(0.5)
			.setScale(this.scaleFactor)

		this.tubeRightTagOriginalPosition = {
			x: baseX,
			y: baseY + 122 * this.scaleFactor,
		}

		this.rightNameTag = this.add
			.image(
				baseX + 80 * this.scaleFactor,
				baseY - 50 * this.scaleFactor,
				creatureTagImage,
			)
			.setOrigin(1)
			.setScale(this.scaleFactor / 2)
			.setVisible(false)

		// Scale up button
		this.rightScaleUpButton = this.createInteractiveElement(
			//baseX + 260 * this.scaleFactor,
			baseX,
			this.gameH / 2 + 20 * this.scaleFactor,
			"scaleUpButtonNew",
			0,
			1,
			() => this.handleScaleUpClick("right"),
		)
	}

	// ---- HELPER METHODS FOR CREATING UI ELEMENTS ----

	createInteractiveElement(x, y, texture, scale, alpha, callback) {
		const element = this.add
			.image(x, y, texture)
			.setOrigin(0.5)
			.setScale(scale)
			.setAlpha(alpha)
			.setInteractive()
			.setDepth(50)

		if (callback) {
			element.on("pointerdown", callback, this)

			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
		}

		return element
	}

	createTubeTaskPanels(side, baseX, baseY) {
		const isLeft = side === "left"
		const offsetX = -170 * this.scaleFactor
		const panelX = baseX + offsetX

		this.panelXReference = panelX // Store for later use

		// Food task holder
		const prefix = isLeft ? "L" : "R"
		this[`${prefix}FoodTaskHolder`] = this.add
			.image(panelX - 20 * this.scaleFactor, baseY, "creatureTaskHolder")
			.setOrigin(0.5)
			.setScale(this.scaleFactor / 2.65)
			.setVisible(false)

		this[`${prefix}FoodTaskPanelImageSmall`] = this.add
			.image(panelX, baseY - 130 * this.scaleFactor, "feedingPanelUnscaled")
			.setOrigin(0.5, 0)
			.setScale(this.scaleFactor * 0.5)

		this[`${prefix}FoodTaskPanelImage`] = this.add
			.image(panelX - 20 * this.scaleFactor, baseY, "feedingPanel")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setVisible(false)

		// Get the current creature and its header text

		const trackingKey = `${prefix}FeedingData`
		this[trackingKey] = {
			foodGrids: {},
			allComplete: false,
		}

		let currentCreature = isLeft
			? this.currentLeftCreature
			: this.currentRightCreature
		let headerText = "Food Type" // Default header

		const taskHeader = this.add
			.image(
				panelX - 18 * this.scaleFactor,
				baseY - 55 * this.scaleFactor,
				"taskHeader",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor, this.scaleFactor)

		this.taskHeaderYPos = taskHeader.y

		if (isLeft) {
			this.taskHeader = taskHeader
		} else {
			this[`${prefix}TaskHeader`] = taskHeader
		}

		// Task header text
		const taskHeaderText = this.add
			.text(taskHeader.x, taskHeader.y, headerText, {
				fontFamily: "Space Grotesk",
				fontSize: 15 * this.scaleFactor,
				color: "rgb(17, 4, 78)",
				align: "left",
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)

		if (isLeft) {
			this.taskHeaderText = taskHeaderText
		} else {
			this[`${prefix}TaskHeaderText`] = taskHeaderText
		}

		// Scan button
		const scanButton = this.add
			.image(
				panelX - 20 * this.scaleFactor,
				baseY + 10 * this.scaleFactor,
				"miniWideBtn",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setInteractive()

		const scanText = this.add
			.text(scanButton.x, scanButton.y - 10 * this.scaleFactor, "SCAN", {
				fontFamily: "Gluten",
				fontSize: this.fontSize + 2 * this.scaleFactor,
				color: "#fff",
				align: "left",
				resolution: 2,
				fontStyle: "bold",
				fontWeight: "700",
			})
			.setOrigin(0.5)

		scanButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			if (this.tutorialHand) {
				this.tutorialHand.destroy()
			}
			destroyTooltip(this)
			destroyIndicator(this)
			scanButton.setVisible(false)
			scanText.setVisible(false)
			//displayInstructions(this, "Scanning in progress...", 12, 200, 60)
			if (isLeft) {
				this.tabletButton.input.enabled = false
				this.leftScaleUpButton.input.enabled = false;
				this.leftScaleUpButton.setAlpha(0.5)
				this.tabletButton.setAlpha(0.5)
				////this.tabletNotification.setVisible(false)
				if (this.notificationBell) {
					this.notificationBell.destroy()
				}
				this.handleScanButtonClick()
			} else {
				this.tabletButton.input.enabled = false
				this.rightScaleUpButton.input.enabled = false;
				this.rightScaleUpButton.setAlpha(0.5)
				this.tabletButton.setAlpha(0.5)
				////this.tabletNotification.setVisible(false)
				if (this.notificationBell) {
					this.notificationBell.destroy()
				}
				this.handleRightScanButtonClick()
			}
			if (this.currentPlanet === 1) {
				if (this.scanOverlayReference) {
					this.scanOverlayReference.remove()
				}
			}

		})

		if (isLeft) {
			this.LScanButton = scanButton
			this.LScanText = scanText
		} else {
			this.RScanButton = scanButton
			this.RScanText = scanText
		}

		// Create food grids based on creature data
		this.createFoodTaskGrids(side)

		// Create the main task grid
		this.createTaskGrid(side)
	}

	createFoodTaskGrids(side) {
		const isLeft = side === "left"
		const prefix = isLeft ? "L" : "R"
		const currentCreature = isLeft
			? this.currentLeftCreature
			: this.currentRightCreature

		// Check and destroy existing grids first
		this.destroyExistingFoodTaskGrids(side)

		// Get creature data from JSON
		this.creatureData = this.cache.json.get("creatureData")
		const creature = this.creatureData.creatures.find(
			({ index }) => index === currentCreature,
		)
		console.log("current CREATURE" + currentCreature)
		// Check how many food types this creature eats
		const foodTypes = creature.food || []
		const foodAmounts = creature.foodAmount || []

		if (isLeft) {
			console.log("L Food Types: " + foodTypes)
			console.log("L Food Amounts: " + foodAmounts)
		} else {
			console.log("R Food Types: " + foodTypes)
			console.log("R Food Amounts: " + foodAmounts)
		}

		// Create a grid for each food type
		for (let i = 0; i < foodTypes.length; i++) {
			this.createSingleFoodTaskGrid(
				side,
				i,
				foodTypes[i],
				8, // Default amount,
				//parseInt(foodAmounts[i], 10),
			)
		}

		// If the cockpit container already exists, update it with new grid items
		if (this.cockpitContainer) {
			// Get all the new food grid children
			const newGridChildren = this.getFoodGridChildren(prefix)

			// Add them to the container
			for (const child of newGridChildren) {
				this.cockpitContainer.add(child)
			}

			console.log(
				`Updated cockpit container with new ${prefix} food task grids`,
			)
		}
	}

	// Method to destroy existing food task grids for a side
	destroyExistingFoodTaskGrids(side) {
		const isLeft = side === "left"
		const prefix = isLeft ? "L" : "R"

		// Clear food types array
		this[`${prefix}FoodTypes`] = []

		// Find and destroy all existing food task grids for this side
		let gridIndex = 0
		let gridName = `${prefix}FoodTaskGrid_${gridIndex}`

		while (this[gridName]) {
			try {
				// If cockpitContainer exists, try to remove grid children from it first
				if (this.cockpitContainer) {
					try {
						const gridChildren = this[gridName].getChildren?.() || []
						for (const child of gridChildren) {
							if (child) {
								this.cockpitContainer.remove(child)
							}
						}
					} catch (e) {
						console.log(
							`Error removing children from cockpit for ${gridName}:`,
							e,
						)
					}
				}

				// Try to destroy all items in the group
				try {
					if (typeof this[gridName].clear === "function") {
						this[gridName].clear(true, true) // destroy children and remove them from scene
					}
				} catch (e) {
					console.log(`Error clearing ${gridName}:`, e)
				}

				// Try to destroy the group itself
				try {
					if (typeof this[gridName].destroy === "function") {
						this[gridName].destroy()
					}
				} catch (e) {
					console.log(`Error destroying ${gridName}:`, e)
				}
			} catch (e) {
				console.log(`Error processing ${gridName}:`, e)
			}

			// Remove the reference
			this[gridName] = null

			// Check for next grid
			gridIndex++
			gridName = `${prefix}FoodTaskGrid_${gridIndex}`
		}

		console.log(`Destroyed existing ${prefix} food task grids`)
	}
	// Helper method to get all food grid children from all food grids for a side
	getFoodGridChildren(prefix) {
		let allChildren = []
		let gridIndex = 0
		let gridName = `${prefix}FoodTaskGrid_${gridIndex}`

		while (this[gridName]) {
			if (this[gridName].getChildren) {
				allChildren = allChildren.concat(this[gridName].getChildren())
			}

			// Check for next grid
			gridIndex++
			gridName = `${prefix}FoodTaskGrid_${gridIndex}`
		}

		return allChildren
	}

	createSingleFoodTaskGrid(side, foodIndex, foodType, amount) {
		const isLeft = side === "left"
		const prefix = isLeft ? "L" : "R"
		const holder = this[`${prefix}FoodTaskHolder`]
		const gridName = `${prefix}FoodTaskGrid_${foodIndex}`

		// Store food type for later use
		if (!this[`${prefix}FoodTypes`]) {
			this[`${prefix}FoodTypes`] = []
		}
		if (!this[`${prefix}FoodAmounts`]) {
			this[`${prefix}FoodAmounts`] = []
		}
		this[`${prefix}FoodTypes`][foodIndex] = foodType
		this[`${prefix}FoodAmounts`][foodIndex] = amount

		// Create a new group for this food type grid
		this[gridName] = this.add.group()

		const totalGridItems = amount
		const columns = 4
		const rows = Math.ceil(totalGridItems / columns)

		// Calculate dimensions
		const actualHolderWidth = holder.width * (this.scaleFactor / 2.65)
		const actualHolderHeight = holder.height * (this.scaleFactor / 5)
		const cellWidth = actualHolderWidth / columns + 2.5 * this.scaleFactor
		const cellHeight = actualHolderHeight / rows
		const xPadding = cellWidth * 0.1
		const yPadding = cellHeight * 0.1

		// Calculate starting Y position based on previous food types
		let taskHeaderY = this.taskHeaderYPos
		let foodStartY = taskHeaderY + 25 * this.scaleFactor

		if (foodIndex > 0) {
			// Calculate where the previous food grids ended
			for (let i = 0; i < foodIndex; i++) {
				const prevAmount = this[`${prefix}FoodAmounts`][i]
				const prevRows = Math.ceil(prevAmount / columns)

				// Add space for the previous task header
				taskHeaderY += 11 * this.scaleFactor

				// Add space for the previous food grid
				taskHeaderY += prevRows * cellHeight + prevRows * yPadding

				// Add some spacing between food types
				taskHeaderY -= 5 * this.scaleFactor
			}

			foodStartY = taskHeaderY + 25 * this.scaleFactor
		}

		// Create grid items
		for (let i = 0; i < totalGridItems; i++) {
			const row = Math.floor(i / columns)
			const col = i % columns
			const x =
				holder.x -
				actualHolderWidth / 2 +
				cellWidth / 2 +
				col * cellWidth +
				xPadding -
				8 * this.scaleFactor
			const y = foodStartY + row * cellHeight + yPadding
			const itemScale = this.scaleFactor

			const gridItem = this.add
				.image(x, y, "emptyFood")
				.setOrigin(0.5)
				.setScale(itemScale)

			// Include food type and food index in the name to differentiate
			gridItem.name = `${prefix}FoodTaskItem_${foodIndex}_${i}`
			gridItem.foodType = foodType

			this[gridName].add(gridItem)
		}

		// Add food type label if there are multiple food types
		if (this[`${prefix}FoodTypes`].length > 1) {
			const labelY = taskHeaderY

			this.taskHeader02 = this.add
				.image(
					this.panelXReference - 18 * this.scaleFactor,
					labelY,
					"taskHeader",
				)
				.setOrigin(0.5)
				.setScale(this.scaleFactor, this.scaleFactor)
				.setVisible(false)
				.setName(`TaskHeader02`)

			this.taskHeader02OriginalPosition = {
				x: this.taskHeader02.x,
				y: this.taskHeader02.y,
			}

			this.foodLabel = this.add
				.text(
					holder.x - actualHolderWidth / 2 + 10 * this.scaleFactor,
					labelY,
					//`Food Type ${foodIndex + 1}`,
					`???`,
					{
						fontFamily: "Space Grotesk",
						fontSize: 15 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						fontWeight: "700",
						fontStyle: "bold",
						resolution: 2,
					},
				)
				.setOrigin(0, 0.5)
				.setVisible(false)

			// Add to the group
			this[gridName].add(this.taskHeader02)
			this[gridName].add(this.foodLabel)
		}
	}

	createTaskGrid(side) {
		const isLeft = side === "left"
		const prefix = isLeft ? "L" : "R"
		const baseX = isLeft ? this.gameW * 1.5 : this.gameW * 3.5
		const baseY = this.gameH / 2
		const panelX = baseX + 170 * this.scaleFactor

		// Task list panel
		const taskListPanelSmall = this.add
			.image(panelX, baseY - 130 * this.scaleFactor, "taskListPanelUnscaled")
			.setOrigin(0.5, 0)
			.setScale(this.scaleFactor * 0.5)

		const taskListPanel = this.add
			.image(
				panelX + 20 * this.scaleFactor,
				baseY - 20 * this.scaleFactor,
				"taskListPanel",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setVisible(false)

		if (isLeft) {
			this.taskListPanelSmall = taskListPanelSmall
			this.taskListPanel = taskListPanel
		} else {
			this[`${prefix}TaskListPanelSmall`] = taskListPanelSmall
			this[`${prefix}TaskListPanel`] = taskListPanel
		}

		const feedMeButton = this.add
			.image(baseX, baseY, "normalWideBtn")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setInteractive()
			.on("pointerdown", () => showFeedingTray(this, side))

		this.foodTrayXPos = baseX - 400 * this.scaleFactor
		const foodTray = this.add.image(
			this.foodTrayXPos - 200 * this.scaleFactor,
			baseY,
			"emptyFoodTray",
		)
		this.foodTrayReference = foodTray
		foodTray.setScale(this.scaleFactor * 0.87)
		foodTray.setVisible(false)

		const foodTrayItems = this.add.group()
		const fedGroup = this.add.group() // Add this for right side

		if (isLeft) {
			this.LFoodTrayItems = foodTrayItems
			this.LFedGroup = fedGroup
		} else {
			this.RFoodTrayItems = foodTrayItems
			this.RFedGroup = fedGroup
		}

		const itemSpacing = 45 * this.scaleFactor // Adjust spacing as needed

		let foodList = []
		if (this.currentPlanet === 1) {
			foodList = [1, 4, 2, 5]
		}

		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel < 7) {
				foodList = [9, 4, 3, 5]
			}

			if (this.savedMiniLevel === 8) {
				foodList = [3, 9, 5, 4]
			}

			if (this.savedMiniLevel > 9) {
				foodList = [5, 3, 9, 8]
			}
		}

		if (this.currentPlanet === 3) {
			foodList = [10, 9, 6, 7]
		}
		for (let i = 0; i < 4; i++) {
			const itemY = foodTray.y - 70 * this.scaleFactor + i * itemSpacing
			const foodTrayItem = this.add
				.image(
					foodTray.x + 20 * this.scaleFactor,
					itemY + 3 * this.scaleFactor,
					"food0" + foodList[i] + "_thumb",
				)
				.setOrigin(0.5)
				.setScale((this.scaleFactor * 0.85) * 0.25)
			foodTrayItem.name = `foodTrayItem_${i}`
			foodTrayItem.setVisible(false)
			foodTrayItem.setInteractive()
			foodTrayItem.on("pointerdown", () => {
				feedingFunctionality(this, side, i + 1)
			})
			foodTrayItems.add(foodTrayItem)
		}

		// Discharge button
		const dischargeButton = this.add
			.image(
				panelX + 20 * this.scaleFactor,
				baseY + 150 * this.scaleFactor,
				"dischargeButton",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor)
			.setDepth(10)
		dischargeButton
			.setInteractive()
			.on("pointerdown", () => this.dischargeFunctionality(side))

		if (isLeft) {
			this[`${prefix}DischargeButton`] = dischargeButton
			this[`${prefix}FeedMeButton`] = feedMeButton
			this[`${prefix}FoodTray`] = foodTray
		} else {
			this[`${prefix}DischargeButton`] = dischargeButton
			this[`${prefix}FeedMeButton`] = feedMeButton
			this[`${prefix}FoodTray`] = foodTray
		}

		// Discharge text
		const dischargeText = this.add
			.text(
				dischargeButton.x,
				dischargeButton.y - 5 * this.scaleFactor,
				"DISCHARGE",
				{
					fontFamily: "Gluten",
					fontSize: this.fontSize + 2 * this.scaleFactor,
					color: "#fff",
					fontWeight: "700",
					fontStyle: "bold",
					align: "left",
					resolution: 2,
				},
			)
			.setOrigin(0.5)

		//FeedMeText
		const feedMeText = this.add
			.text(feedMeButton.x, feedMeButton.y - 5 * this.scaleFactor, "FEED ME!", {
				fontFamily: "Gluten",
				fontSize: this.fontSize + 2 * this.scaleFactor,
				color: "#fff",
				align: "left",
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)

		if (isLeft) {
			this[`${prefix}DischargeText`] = dischargeText
			this[`${prefix}FeedMeText`] = feedMeText
		} else {
			this[`${prefix}DischargeText`] = dischargeText
			this[`${prefix}FeedMeText`] = feedMeText
		}

		// Task holder
		const taskHolder = this.add
			.image(
				panelX + 20 * this.scaleFactor,
				baseY + 10 * this.scaleFactor,
				"creatureTaskHolder",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor / 2.65)
			.setVisible(false)

		if (isLeft) {
			this[`${prefix}TaskHolder`] = taskHolder
		} else {
			this[`${prefix}TaskHolder`] = taskHolder
		}

		// Create task items group
		const taskGrid = this.add.group()
		if (isLeft) {
			this[`${prefix}TaskGrid`] = taskGrid
		} else {
			this[`${prefix}TaskGrid`] = taskGrid
		}

		// Configuration for task items
		const taskRows = 4
		const taskColumns = 1
		const actualHolderWidth = taskHolder.width * (this.scaleFactor / 2.65)
		const actualHolderHeight = taskHolder.height * (this.scaleFactor / 2.65)
		const cellHeight = actualHolderHeight / taskRows
		const yPadding = cellHeight * 0.1

		// Create task items
		for (let row = 0; row < taskRows; row++) {
			const x = taskHolder.x
			const y =
				taskHolder.y -
				actualHolderHeight / 2 +
				cellHeight / 2 +
				row * cellHeight +
				yPadding
			const itemScale = this.scaleFactor

			const taskImage = this.add
				.image(x, y, "taskInactive")
				.setOrigin(0.5)
				.setScale(itemScale)

			const taskText = this.add
				.text(
					taskImage.x - 30 * this.scaleFactor,
					taskImage.y - 10 * this.scaleFactor,
					`Task ${row + 1}`,
					{
						fontFamily: "Space Grotesk",
						fontSize: 15 * this.scaleFactor,
						color: "#11044E",
						align: "left",
						fontWeight: "700",
						fontStyle: "bold",
						resolution: 2,
					},
				)
				.setOrigin(0)

			switch (row) {
				case 0:
					taskText.setText("ID")
					break
				case 1:
					taskText.setText("Assess")
					break
				case 2:
					taskText.setText("Feed")
					break
				case 3:
					taskText.setText("Log")
					break
				default:
					break
			}

			taskGrid.add(taskImage)
			taskImage.name = `task${row + 1}`
			taskGrid.add(taskText)
		}
		taskGrid.name = "taskGrid"
	}
	changeTaskTexture(taskNumber, textureName, side) {
		const prefix = side === "left" ? "L" : "R"
		const taskGrid = this[`${prefix}TaskGrid`]

		taskGrid.children.each((child) => {
			if (child.name == `task${taskNumber}`) {
				child.setTexture(textureName)
			}
		})
	}

	createCockpitContainer() {
		// Create an array to hold all elements
		let elements = [
			// Front side
			this.cockpitFront,
			this.fuelGauge,
			this.radar,
			this.planetNamePanel,
			this.ornament,

			// Back side
			this.cockpitBack,
		]

		// Left side base elements
		const leftBaseElements = [
			this.leftSide,
			this.leftSideZoomed.setVisible(false),
			this.LFoodTaskHolder,
			this.LFoodTaskPanelImageSmall,
			this.LFoodTaskPanelImage,
			this.taskHeader,
			this.LScanButton,
			this.LScanText,
			this.taskHeaderText,
			this.taskListPanelSmall,
			this.taskListPanel,
			this.LDischargeButton,
			this.LDischargeText,
			this.LTaskHolder,
			this.leftTubeBack,
			this.creatureTubeL,
			this.leftTubeFront,
			this.leftTubeTag,
			this.leftNameTag,
			this.leftScaleUpButton,
			this.LFeedMeButton,
			this.LFeedMeText,
			this.LFoodTray,
		]

		// Right side base elements
		const rightBaseElements = [
			this.tubeR,
			this.rightSideZoomed.setVisible(false),
			this.RFoodTaskHolder,
			this.RFoodTaskPanelImageSmall,
			this.RFoodTaskPanelImage,
			this.RTaskHeader,
			this.RTaskHeaderText,
			this.RScanButton,
			this.RScanText,
			this.RTaskListPanelSmall,
			this.RTaskListPanel,
			this.RDischargeButton,
			this.RDischargeText,
			this.RTaskHolder,
			this.rightTubeBack,
			this.creatureTubeR,
			this.rightTubeFront,
			this.rightTubeTag,
			this.rightNameTag,
			this.rightScaleUpButton,
			this.RFeedMeButton,
			this.RFeedMeText,
			this.RFoodTray,
		]

		// Add base elements to the elements array
		elements = elements.concat(leftBaseElements, rightBaseElements)

		// if (this.taskHeader02) {
		// 	elements = elements.concat(this.taskHeader02)
		// }

		// if (this.foodLabel) {
		// 	elements = elements.concat(this.foodLabel)
		// }

		// Add the task grid children
		if (this.LTaskGrid && this.LTaskGrid.getChildren) {
			elements = elements.concat(this.LTaskGrid.getChildren())
		}
		if (this.RTaskGrid && this.RTaskGrid.getChildren) {
			elements = elements.concat(this.RTaskGrid.getChildren())
		}

		// Add food tray items
		if (this.LFoodTrayItems && this.LFoodTrayItems.getChildren) {
			elements = elements.concat(this.LFoodTrayItems.getChildren())
		}
		if (this.RFoodTrayItems && this.RFoodTrayItems.getChildren) {
			elements = elements.concat(this.RFoodTrayItems.getChildren())
		}

		// Add fed group items
		if (this.LFedGroup && this.LFedGroup.getChildren) {
			elements = elements.concat(this.LFedGroup.getChildren())
		}
		if (this.RFedGroup && this.RFedGroup.getChildren) {
			elements = elements.concat(this.RFedGroup.getChildren())
		}

		// Add all food task grid children (now handling multiple food grids)
		const foodGridsL = this.getFoodGridChildren("L")
		const foodGridsR = this.getFoodGridChildren("R")
		elements = elements.concat(foodGridsL, foodGridsR)

		// Create the container
		this.cockpitContainer = this.add.container(0, 0, elements)

		// Create duplicate elements for seamless looping
		this.createLoopElements()
	}

	// Helper method to get all food grid children
	getFoodGridChildren(prefix) {
		let allChildren = []

		// Check how many food grids we have
		let gridIndex = 0
		let gridName = `${prefix}FoodTaskGrid_${gridIndex}`

		// Keep looking for food grids with incrementing indices
		while (this[gridName]) {
			if (this[gridName].getChildren) {
				allChildren = allChildren.concat(this[gridName].getChildren())
			}
			gridIndex++
			gridName = `${prefix}FoodTaskGrid_${gridIndex}`
		}

		// If we found no indexed food grids, try the old single-grid format as fallback
		if (
			allChildren.length === 0 &&
			this[`${prefix}FoodTaskGrid`] &&
			this[`${prefix}FoodTaskGrid`].getChildren
		) {
			allChildren = this[`${prefix}FoodTaskGrid`].getChildren()
		}

		return allChildren
	}

	createLoopElements() {
		// Duplicate of first page at the end (after the last page)
		this.duplicateFirst = this.add
			.image(
				this.gameW * 4.5,
				this.gameH / 2,
				"cockpitFront_" + this.currentPlanet,
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)

		this.duplicateFuelGauge = this.add
			.image(
				this.gameW * 4.5 + 5 * this.scaleFactor,
				this.gameH / 2 - 37 * this.scaleFactor,
				this.currentFuelState,
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.3)

		const PLANET_PANELS = {
			1: "hypotheraPanel",
			2: "stratosomaPanel",
			3: "emberonPanel",
		}

		let planetName = PLANET_PANELS[this.currentPlanet] || ""

		// this.duplicatePlanetNamePanel = this.add
		// 	.image(
		// 		this.gameW * 4.5 - 350 * this.scaleFactor,
		// 		this.gameH / 2 - 50 * this.scaleFactor,
		// 		planetName,
		// 	)
		// 	.setOrigin(0.5)
		// 	.setScale(this.scaleFactor)
		// 	.setVisible(false)

		this.duplicatePlanetNamePanel = this.add
			.image(
				this.gameW * 4.5 + 200 * this.scaleFactor,
				this.gameH / 2 - 8 * this.scaleFactor,
				planetName,
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor / 2)

		// Decorative ornament
		this.duplicateOrnament = this.add
			.image(
				this.gameW * 4.5 - 350 * this.scaleFactor,
				this.gameH / 2 - 50 * this.scaleFactor,
				"ornament0" + this.savedOrnament,
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor / 3)

		// Duplicate of last page at the beginning (before the first page)
		this.duplicateLast = this.add
			.image(-this.gameW * 0.5, this.gameH / 2, "tubeL_" + this.currentPlanet)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)

		let creatureImage

		if (this.savedUserData.currentPlanet === 1) {
			creatureImage = "creature02_hungry"
			this.currentRightCreature = 2
		}
		if (this.savedUserData.currentPlanet === 2) {
			creatureImage = "creature04_hungry"
			//or creature06_hungry if 04 is already discharged
			this.currentRightCreature = 4
			//or 5 if 3 is already discharged
		}
		if (this.savedUserData.currentPlanet === 3) {
			creatureImage = "creature07_hungry"
			//or creature06_hungry if 08 is already discharged
			this.currentRightCreature = 7
			//or 8 if 6 is already discharged
		}
		// Additional duplicate elements
		this.rightTubeCreature = this.add
			.image(-this.gameW * 0.5, this.gameH / 2, creatureImage)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.35)

		if (this.currentPlanet === 1) {
			this.rightTubeCreature.setScale(this.scaleFactor * 0.25)
		}
		if (this.currentPlanet === 2) {
			this.rightTubeCreature.setScale(this.scaleFactor * 0.25)
			this.rightTubeCreature.y += 10 * this.scaleFactor
		}
		if (this.currentPlanet === 3) {
			this.rightTubeCreature.setScale(this.scaleFactor * 0.25)
			this.rightTubeCreature.y += 20 * this.scaleFactor
		}

		this.duplicateRightTubeBack = this.add
			.image(-this.gameW * 0.5, this.gameH / 2, "tubeBack")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.8)

		this.duplicateRightTubeFront = this.add
			.image(-this.gameW * 0.5, this.gameH / 2, "tubeFront")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.8)

		this.duplicateRFoodTaskPanelImageSmall = this.add
			.image(
				-this.gameW / 2 - 170 * this.scaleFactor,
				this.gameH / 2 - 130 * this.scaleFactor,
				"feedingPanelUnscaled",
			)
			.setOrigin(0.5, 0)
			.setScale(this.scaleFactor * 0.5)

		// this.duplicateRTaskListPanelSmall = this.add
		// 	.image(
		// 		-this.gameW / 2 + 170 * this.scaleFactor,
		// 		this.gameH / 2, - 130 * this.scaleFactor,
		// 		"taskListPanelUnscaled",
		// 	).setOrigin(0.5, 0)
		// 	.setScale(this.scaleFactor)

		this.duplicateRTaskListPanelSmall = this.add
			.image(
				-this.gameW / 2 + 170 * this.scaleFactor,
				this.gameH / 2 - 130 * this.scaleFactor,
				"taskListPanelUnscaled",
			)
			.setOrigin(0.5, 0)
			.setScale(this.scaleFactor * 0.5)

		this.duplicateRightScaleUpButton = this.add
			.image(
				-this.gameW / 2,
				this.gameH / 2 + 20 * this.scaleFactor,
				"scaleUpButtonNew",
			)
			.setAlpha(0.5)
			.setScale(this.scaleFactor * 0.5)

		this.duplicateRightTubeTag = this.add
			.image(
				-this.gameW / 2,
				this.gameH / 2 + 122 * this.scaleFactor,
				"tube2LabelSmall",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor)

		// Add duplicates to container
		this.cockpitContainer.add([
			this.duplicateFirst,
			this.duplicateFuelGauge,
			this.duplicatePlanetNamePanel,
			this.duplicateOrnament,
			this.duplicateLast,
			this.duplicateRightTubeBack,
			this.rightTubeCreature,
			this.duplicateRFoodTaskPanelImageSmall,
			this.duplicateRTaskListPanelSmall,
			this.duplicateRightTubeFront,
			this.duplicateRightScaleUpButton,
			this.duplicateRightTubeTag,
		])
	}

	createNavigationButtons() {
		// Forward navigation button
		this.frontButton = this.add
			.image(
				this.safeZoneWidth - 160 * this.scaleFactor,
				this.gameH - 60 * this.scaleFactor,
				"rightButton",
			)
			.setInteractive()
			.setScale(this.scaleFactor * 0.28)
		this.frontButton.on("pointerdown", () => this.moveCockpit(-1))

		// Backward navigation button
		this.backButton = this.add
			.image(
				this.safeZoneWidth / 2 - 280 * this.scaleFactor,
				this.gameH - 60 * this.scaleFactor,
				"leftButton",
			)
			.setInteractive()
			.setScale(this.scaleFactor * 0.28)
		this.backButton.on("pointerdown", () => this.moveCockpit(1))

		// Tablet button
		this.tabletButton = this.add
			.image(
				this.safeZoneWidth / 2 - 360 * this.scaleFactor,
				this.gameH - 60 * this.scaleFactor,
				"tabletButton",
			)
			.setOrigin(0.5)
			.setScale(this.tabletButtonScale)
			.setInteractive()
			.setVisible(true)

		this.tabletButton.on(
			"pointerdown",
			function () {
				if (this.notificationBell) {
					this.notificationBell.destroy()
				}
				if (this.savedMiniLevel === 0) {
					console.log("MINILEVEL NO PRESS")
					return
				}
				if (this.currentPlanet === 1) {
					if (this.tabletOverlayReference) {
						this.tabletOverlayReference.remove()
					}
				}
				if (this.tutorialHand) {
					this.tutorialHand.destroy()
				}
				playUISound(this, this.soundManager, "open-tablet", 0.25)
				// destroyInstructions(this);
				// destroyTooltip(this);
				destroyIndicator(this)
				destroyTooltip(this)
				this.scene.launch("TabletScene")
				this.scene.launch("TabletUI")
				this.scene.pause("CockpitScene")
			},
			this,
		)

		// Notification bell
		// this.tabletNotification = this.add
		// 	.image(
		// 		this.tabletButton.x + 40 * this.scaleFactor,
		// 		this.tabletButton.y - 40 * this.scaleFactor,
		// 		"notificationBell",
		// 	)
		// 	.setOrigin(0.5)
		// 	.setScale(0)
	}

	// ---- EVENT HANDLERS ----

	handleScanButtonClick() {
		this.leftScaleUpButton.input.enabled = false;

		// Update mini level
		// updateMiniLevel(this.savedMiniLevel);
		if (this.tutorialHand) {
			this.tutorialHand.destroy()
		}
		this.soundManager.addCategory("UI", 0.5)

		this.soundManager.playEffect("Computer_data_sound", {
			volume: 0.6,
			category: "ui",
		})

		destroyInstructions(this)

		destroyIndicator(this)
		this.scan.setVisible(true)

		// Play scan animation
		this.scan.play("creature_scan")

		// Handle animation completion
		this.scan.on("animationcomplete", () => {
			destroyInstructions(this)
			handleGameProgressUpdate(this)
			this.savedUserData = checkLocalSavedData()
			this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
			console.log("Scanned MiniLevel: " + this.savedMiniLevel)
			if (this.currentPlanet === 3 && this.savedMiniLevel === 1) {
				this.leftScaleUpButton.input.enabled = false
				this.leftScaleUpButton.setAlpha(0.5)
				return
			}
			playTickAnimation(this, {
				xPos: this.gameW / 2,
				yPos: this.gameH / 2
			})
			if (this.currentPlanet === 2 && this.savedMiniLevel === 13) {
				console.log("Enable Bool")
				let tabletScene = this.scene.get("TabletScene")
				let creatureDatabaseScene = this.scene.get("CreatureDatabase")

				tabletScene.showTabletBool = true
				creatureDatabaseScene.showTabletBool = true
			}
			if (this.currentPlanet === 3 && this.savedMiniLevel === 16) {
				updateMiniLevel(this.savedMiniLevel)
				handleGameProgressUpdate(this)
				return
			}

			this.time.delayedCall(2000, () => {

				this.taskHeader.setVisible(true)
				this.taskHeaderText.setVisible(true)
				this.taskHeaderText.setText("???")
				this.tabletButton.setVisible(true)
				this.tabletButton.input.enabled = true
				this.showAllFoodTaskGrids("L")

				this.leftNameTag.setVisible(true)
			})

			if (this.currentPlanet === 3) {
				console.log("Current Creature: " + this.currentLeftCreature)
				if (this.currentLeftCreature === 6) {
					this.leftNameTag.x += 10 * this.scaleFactor
				}

				if (this.currentLeftCreature === 8) {
					this.leftNameTag.x += 10 * this.scaleFactor
				}

				if (this.currentLeftCreature >= 16) {
					this.leftNameTag.x += 30 * this.scaleFactor
				}
			} else {
				this.leftNameTag.setPosition(
					this.leftNameTag.x + 20 * this.scaleFactor,
					this.leftNameTag.y - 1 * this.scaleFactor,
				)
			}
		})
	}

	handleRightScanButtonClick() {
		this.soundManager.playEffect("Computer_data_sound", {
			volume: 0.6,
			category: "ui",
		})
		// this.rightScaleUpButton.input.enabled = false
		// this.rightScaleUpButton.setAlpha(0.5)
		// Update mini level
		updateMiniLevel(this.savedMiniLevel)

		this.savedUserData = checkLocalSavedData()
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		console.log("Scanned MiniLevel: " + this.savedMiniLevel)

		this.scan.setVisible(true)

		// Play scan animation
		this.scan.play("creature_scan")

		// Handle animation completion
		this.scan.on("animationcomplete", () => {

			playTickAnimation(this, {
				xPos: this.gameW / 2,
				yPos: this.gameH / 2
			})

			this.time.delayedCall(2000, () => {
				this.RScanButton.setVisible(false)
				this.RScanText.setVisible(false)

				this.RTaskHeader.setVisible(true)
				this.RTaskHeaderText.setVisible(true)
				this.RTaskHeaderText.setText("???")
				this.showAllFoodTaskGrids("R")
				if (this.currentPlanet <= 2) {
					//this.LTaskHeaderText.setVisible(false);
					//this.RFoodTaskHolder.setVisible(true);
					this.RTaskGrid.setVisible(true)
				} else {
					//hideAllFoodTaskGrids('L');
					//this.RFoodTaskHolder.setVisible(true);
					this.RTaskGrid.setVisible(true)
				}
				this.RTaskGrid.setVisible(true)

				this.rightNameTag.setVisible(true)
				this.rightNameTag.setPosition(
					this.rightNameTag.x + 20 * this.scaleFactor,
					this.rightNameTag.y - 1 * this.scaleFactor,
				)

				//this.tabletNotification.setScale(0)


				////this.tabletNotification.setVisible(true)
				playNotificationAnimation(this, {
					xPos: this.tabletButton.x + 40 * this.scaleFactor,
					yPos: this.tabletButton.y - 40 * this.scaleFactor
				})

				this.tabletButton.setAlpha(1)
				// this.tweens.add({
				// 	targets: this.tabletNotification,
				// 	scale: this.tabletNotifScale / 2,
				// 	ease: "Back.Out",
				// 	duration: 100,
				// })
				this.tabletButton.input.enabled = true
			})
		})
	}

	handleScaleUpClick(side) {
		playUISound(this, this.soundManager, "Subtle click 1", 0.25)
		destroyTooltip(this)
		if (this.tutorialHand) {
			this.tutorialHand.destroy()
		}
		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 0) {
				//displayTooltip(this, this.LScanButton.x - this.gameW, this.LScanButton.y - 65 * this.scaleFactor, 'small', 'Up', 'Press here to scan your creature', 15);
				displayTooltip(this, {
					xPos: this.LScanButton.x - this.gameW,
					yPos: this.LScanButton.y - 65 * this.scaleFactor,
					type: "pressToScanTip",
					scale: 1,
					text: "Press to scan",
					fontScale: -8,
					xTextOffset: 0,
					yTextOffset: -9,
					wrapWidth: 1.1,
				})
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)
				if (this.lScaleOverlayReference) {
					this.lScaleOverlayReference.remove()
				}
				const overlay = phaserOverlay(this);

				const button = this.LScanButton

				overlay.setTargetByCoords(
					this.LScanButton.x - this.gameW - 55 * this.scaleFactor,
					this.LScanButton.y - 65 * this.scaleFactor + 32 * this.scaleFactor,
					button.width * this.scaleFactor * 0.5,
					button.height * this.scaleFactor * 0.5,
					15
				)

				overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.instructionBgContainer, this.instructionBgCenter, this.instructionBgRight, this.instructionText])

				this.scanOverlayReference = overlay
			}

			if (this.savedMiniLevel === 5) {
				//displayTooltip(this, this.RScanButton.x - this.gameW, this.RScanButton.y - 65 * this.scaleFactor, 'small', 'Up', 'Press here to scan your creature', 15);
				displayTooltip(this, {
					xPos: this.RScanButton.x - this.gameW * 3,
					yPos: this.RScanButton.y - 65 * this.scaleFactor,
					type: "pressToScanTip",
					scale: 1,
					text: "Press to scan",
					fontScale: -8,
					xTextOffset: 0,
					yTextOffset: -9,
					wrapWidth: 1.1,
				})
				displayIndicator(
					this,
					this.RScanButton.x - this.gameW * 3,
					this.RScanButton.y - 3 * this.scaleFactor,
					1,
					"scanIndicator",
				)
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)
			}
		}

		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel === 0) {
				//displayIndicator(this, this.LScanButton.x - this.gameW, this.LScanButton.y - 5 * this.scaleFactor, 1 * this.scaleFactor, 0.65 * this.scaleFactor);
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)

				displayTutorialHand(this, {
					xPos: this.LScanButton.x - this.gameW + 100 * this.scaleFactor,
					yPos: this.LScanButton.y - 20 * this.scaleFactor,
					rotation: -90
				})
			}

			if (this.savedMiniLevel === 5) {
				//displayTooltip(this, this.RScanButton.x - this.gameW, this.RScanButton.y - 65 * this.scaleFactor, 'small', 'Up', 'Press here to scan your creature', 15);
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)

				displayTutorialHand(this, {
					xPos: this.RScanButton.x - this.gameW * 3 + 100 * this.scaleFactor,
					yPos: this.RScanButton.y - 20 * this.scaleFactor,
					rotation: -90
				})
			}

			if (this.savedMiniLevel === 13) {
				//displayTooltip(this, this.RScanButton.x - this.gameW, this.RScanButton.y - 65 * this.scaleFactor, 'small', 'Up', 'Press here to scan your creature', 15);
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)
				this.creature3Bool = true
				console.log("creature3Bool: " + this.creature3Bool)

				this.planet2Creature3ScaledIn = true
			}

			const prefix = side === "left" ? "L" : "R"

			this[`${prefix}FoodTrayItems`].getChildren().forEach((item) => {
				//item.setVisible(false)
				item.setAlpha(1)
				item.input.enabled = true
			})
		}

		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel === 0) {
				//displayIndicator(this, this.LScanButton.x - this.gameW, this.LScanButton.y - 5 * this.scaleFactor, 1 * this.scaleFactor, 0.65 * this.scaleFactor);
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)

				// displayTooltip(this, {
				// 	xPos: this.LScanButton.x - this.gameW,
				// 	yPos: this.LScanButton.y - 65 * this.scaleFactor,
				// 	type: "pressToScanTip",
				// 	scale: 1,
				// 	text: "Press to re-scan",
				// 	fontScale: -8,
				// 	xTextOffset: 0,
				// 	yTextOffset: -9,
				// 	wrapWidth: 1.1,
				// })
				this.creatureTubeL.y += 10 * this.scaleFactor
			}

			if (this.savedMiniLevel === 9 && side === "right") {
				//displayTooltip(this, this.RScanButton.x - this.gameW, this.RScanButton.y - 65 * this.scaleFactor, 'small', 'Up', 'Press here to scan your creature', 15);
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)
			}

			if (this.savedMiniLevel === 13) {
				this.creature3Bool = true
				//displayTooltip(this, this.RScanButton.x - this.gameW, this.RScanButton.y - 65 * this.scaleFactor, 'small', 'Up', 'Press here to scan your creature', 15);
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)
			}
			if (this.savedMiniLevel === 16 && side === "left") {
				//displayTooltip(this, this.RScanButton.x - this.gameW, this.RScanButton.y - 65 * this.scaleFactor, 'small', 'Up', 'Press here to scan your creature', 15);
				displayInstructions(
					this,
					"Scan the creature to find out what it needs",
					12,
					350,
					60,
				)
			}
		}

		const scaleUpButton =
			side === "left" ? this.leftScaleUpButton : this.rightScaleUpButton
		const scanButton = side === "left" ? this.LScanButton : this.RScanButton
		const scanText = side === "left" ? this.LScanText : this.RScanText
		const zoomedSide =
			side === "left" ? this.leftSideZoomed : this.rightSideZoomed

		let baseX = 0
		if (side === "left") {
			baseX = this.gameW * 1.5
		}
		else {
			baseX = this.gameW * 3.5
		}

		const baseY = this.gameH / 2

		scaleUpButton.setTexture("scaleDownButtonNew")
		// scaleUpButton.input.enabled = false
		// scaleUpButton.setAlpha(0.5)

		scanButton.setVisible(true)
		scanText.setVisible(true)
		scanButton.setAlpha(1)

		if (side === "left") {
			scaleUpButton.setPosition(baseX - 320 * this.scaleFactor, 40 * this.scaleFactor)

			if (this.currentPlanet === 1 || this.currentPlanet === 2) {
				if (this.savedMiniLevel === 1) {
					this.LTaskGrid.setVisible(true)
				}

				if (this.savedMiniLevel > 0 && this.savedMiniLevel < 13) {
					scanButton.setVisible(false)
					scanText.setVisible(false)
					scanButton.setAlpha(0.5)

					this.showAllFoodTaskGrids("L")
					this.leftNameTag.setVisible(true)

					this.taskHeader.setVisible(true)
					this.taskHeaderText.setVisible(true)
				}
			}

			if (this.currentPlanet === 2 && this.savedMiniLevel >= 14) {
				scanButton.setVisible(false)
				scanText.setVisible(false)
				scanButton.setAlpha(0.5)

				this.showAllFoodTaskGrids("L")
				this.leftNameTag.setVisible(true)

				this.taskHeader.setVisible(true)
				this.taskHeaderText.setVisible(true)
			}

			if (
				this.currentPlanet === 3 &&
				this.savedMiniLevel >= 4 &&
				this.savedMiniLevel < 16
			) {
				scanButton.setVisible(false)
				scanText.setVisible(false)
				scanButton.setAlpha(0.5)

				this.showAllFoodTaskGrids("L")
				this.leftNameTag.setVisible(true)

				this.taskHeader.setVisible(true)
				this.taskHeaderText.setVisible(true)
			}

			if (this.currentPlanet === 3 && this.savedMiniLevel > 16) {
				scanButton.setVisible(false)
				scanText.setVisible(false)
				scanButton.setAlpha(0.5)

				this.showAllFoodTaskGrids("L")
				this.leftNameTag.setVisible(true)

				this.taskHeader.setVisible(true)
				this.taskHeaderText.setVisible(true)
			}
		} else {
			scaleUpButton.setPosition(baseX - 320 * this.scaleFactor, 40 * this.scaleFactor)

			if (this.currentPlanet === 1 || this.currentPlanet === 2) {
				if (this.savedMiniLevel >= 6) {
					scanButton.setVisible(false)
					scanText.setVisible(false)
					scanButton.setAlpha(0.5)

					this.showAllFoodTaskGrids("R")
					this.rightNameTag.setVisible(true)

					this.RTaskHeader.setVisible(true)
					this.RTaskHeaderText.setVisible(true)
				}

				if (this.savedMiniLevel === 6) {
					this.RTaskGrid.setVisible(true)
				}
			}

			if (this.currentPlanet === 2 && this.savedMiniLevel === 13) {
				this.hideAllFoodTaskGrids("L")
			}

			if (this.currentPlanet === 3) {
				if (this.savedMiniLevel >= 10 && this.savedMiniLevel < 15) {
					scanButton.setVisible(false)
					scanText.setVisible(false)
					scanButton.setAlpha(0.5)

					this.showAllFoodTaskGrids("R")
					this.rightNameTag.setVisible(true)

					this.RTaskHeader.setVisible(true)
					this.RTaskHeaderText.setVisible(true)
				}

				if (this.savedMiniLevel === 6) {
					this.RTaskGrid.setVisible(true)
				}
			}
		}



		console.log("Show Scan Indicator")
		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel === 0) {
				displayIndicator(
					this,
					scanButton.x - this.gameW,
					scanButton.y - 3 * this.scaleFactor,
					1,
					"scanIndicator",
				)
			}
		}
		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel === 5) {
				console.log(
					"Here is our onother current mini level ===>",
					this.savedMiniLevel,
				)
				displayIndicator(
					this,
					scanButton.x - this.gameW * 3.5,
					scanButton.y - 3 * this.scaleFactor,
					1,
					"scanIndicator",
				)
			}
		}
		this.frontButton.setVisible(false)
		this.backButton.setVisible(false)

		if (side === "left") {
			this.LFoodTaskPanelImageSmall.setVisible(false)
			this.LFoodTaskPanelImage.setVisible(true)
			this.taskListPanelSmall.setVisible(false)
			this.taskListPanel.setVisible(true)
			this.leftScaleUpButton.setTexture("scaleDownButtonNew")
			this.LDischargeButton.setVisible(true)
			this.LDischargeText.setVisible(true)
			this.LDischargeButton.setAlpha(0.5)
			this.LDischargeButton.input.enabled = false
			this.LDischargeText.setAlpha(0.5)
			this.leftTubeBack.setTexture("tubeBackScaled")
			this.leftTubeBack.setScale(this.scaleFactor)
			this.leftTubeFront.setTexture("tubeFrontScaled")
			this.leftTubeFront.setScale(this.scaleFactor)
			this.leftTubeTag.setTexture("tube1Label")
			this.leftTubeTag.setPosition(
				this.leftTubeTag.x,
				this.leftTubeTag.y + 30 * this.scaleFactor,
			)

			if (this.currentPlanet === 1) {
				this.creatureTubeL.setScale((this.scaleFactor * 1.3) * 0.25)
			}
			if (this.currentPlanet === 2) {
				this.creatureTubeL.setScale((this.scaleFactor * 1.3) * 0.25)
			}
			if (this.currentPlanet === 3) {
				this.creatureTubeL.setScale(this.scaleFactor * 0.3)
			}
		} else {
			this.RFoodTaskPanelImageSmall.setVisible(false)
			this.RFoodTaskPanelImage.setVisible(true)
			this.RTaskListPanelSmall.setVisible(false)
			this.RTaskListPanel.setVisible(true)
			this.rightScaleUpButton.setTexture("scaleDownButtonNew")
			this.RDischargeButton.setVisible(true)
			this.RDischargeText.setVisible(true)
			this.rightTubeBack.setTexture("tubeBackScaled")
			this.rightTubeBack.setScale(this.scaleFactor)
			this.rightTubeFront.setTexture("tubeFrontScaled")
			this.rightTubeFront.setScale(this.scaleFactor)
			this.rightTubeTag.setTexture("tube2Label")
			this.rightTubeTag.setPosition(
				this.rightTubeTag.x,
				this.rightTubeTag.y + 30 * this.scaleFactor,
			)
			if (this.currentPlanet === 1) {
				this.creatureTubeR.setScale((this.scaleFactor * 1.3) * 0.25)
			}
			if (this.currentPlanet === 2) {
				this.creatureTubeR.setScale((this.scaleFactor * 1.3) * 0.25)
			}
			if (this.currentPlanet === 3) {
				this.creatureTubeR.setScale(this.scaleFactor * 0.3)
			}
		}
		zoomedSide.setVisible(!zoomedSide.visible)
		//unzoomedSide.setVisible(!unzoomedSide.visible)
		if (!zoomedSide.visible) {
			destroyInstructions(this)
			if (this.tutorialHand) {
				this.tutorialHand.destroy()
			}

			destroyTooltip(this)
			scanButton.setVisible(false)
			scanText.setVisible(false)
			destroyIndicator(this)
			this.frontButton.setVisible(true)
			this.backButton.setVisible(true)
			this.savedUserData = checkLocalSavedData()
			this.savedLevel = this.savedUserData?.userLevel || 0
			this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
			console.log("Current mini level: " + this.savedMiniLevel)
			if (side === "left") {
				if (this.currentPlanet === 1) {
					if (this.zoomOutOverlay) {
						this.zoomOutOverlay.remove()
					}
				}

				this.LFoodTaskPanelImageSmall.setVisible(true)
				this.LFoodTaskPanelImage.setVisible(false)
				this.taskListPanelSmall.setVisible(true)
				this.taskListPanel.setVisible(false)
				this.taskHeader.setVisible(false)
				this.taskHeaderText.setVisible(false)
				this.hideAllFoodTaskGrids("L")
				this.LTaskGrid.setVisible(false)
				this.leftScaleUpButton.setTexture("scaleUpButtonNew")
				this.leftScaleUpButton.setPosition(
					baseX,
					this.gameH / 2 + 20 * this.scaleFactor
				)
				this.LDischargeButton.setVisible(false)
				this.LDischargeText.setVisible(false)
				this.leftNameTag.setVisible(false)
				this.leftNameTag.setPosition(
					this.originalTagPosition.x,
					this.originalTagPosition.y,
				)
				this.leftTubeTag.setPosition(
					this.tubeTagOriginalPosition.x,
					this.tubeTagOriginalPosition.y,
				)
				this.leftTubeBack.setTexture("tubeBack")
				this.leftTubeBack.setScale(this.scaleFactor * 0.8)
				this.leftTubeFront.setTexture("tubeFront")
				this.leftTubeFront.setScale(this.scaleFactor * 0.8)
				this.leftTubeTag.setTexture("tube1LabelSmall")
				if (this.currentPlanet === 1) {
					this.creatureTubeL.setScale(this.scaleFactor * 0.25)
				}
				if (this.currentPlanet === 2) {
					this.creatureTubeL.setScale(this.originalCreatureLScale)
				}
				if (this.currentPlanet === 3) {
					this.creatureTubeL.setScale(this.scaleFactor * 0.25)
					console.log("Creature Texture: " + this.creatureTubeL.texture.key)
					if (this.creatureTubeL.texture.key === "creature06_hungry") {
						this.creatureTubeL.y = this.originalTubeLYPos
					}

					if (this.savedMiniLevel === 17) {
						this.leftScaleUpButton.input.enabled = false
						this.leftScaleUpButton.setAlpha(0.5)
					}
				}
			} else {
				this.RFoodTaskPanelImageSmall.setVisible(true)
				this.RFoodTaskPanelImage.setVisible(false)
				this.RTaskListPanelSmall.setVisible(true)
				this.RTaskListPanel.setVisible(false)
				this.RTaskHeader.setVisible(false)
				this.RTaskHeaderText.setVisible(false)
				this.hideAllFoodTaskGrids("R")
				this.RTaskGrid.setVisible(false)
				this.rightScaleUpButton.setTexture("scaleUpButtonNew")
				this.rightScaleUpButton.setPosition(
					baseX,
					this.gameH / 2 + 20 * this.scaleFactor
				)

				this.RDischargeButton.setVisible(false)
				this.RDischargeText.setVisible(false)
				this.rightNameTag.setVisible(false)
				this.rightTubeBack.setTexture("tubeBack")
				this.rightTubeBack.setScale(this.scaleFactor * 0.8)
				this.rightTubeFront.setTexture("tubeFront")
				this.rightTubeFront.setScale(this.scaleFactor * 0.8)
				this.rightTubeTag.setTexture("tube2LabelSmall")
				this.rightTubeTag.setPosition(
					this.tubeRightTagOriginalPosition.x,
					this.tubeRightTagOriginalPosition.y,
				)
				if (this.currentPlanet === 1) {
					this.creatureTubeR.setScale(this.scaleFactor * 0.25)
				}
				if (this.currentPlanet === 2) {
					this.creatureTubeR.setScale(this.scaleFactor * 0.25)
				}
				if (this.currentPlanet === 3) {
					this.creatureTubeR.setScale(this.scaleFactor * 0.25)
				}

				if (this.currentPlanet === 3 && this.savedMiniLevel === 17) {
					this.creature3Panel()
				}
			}
			if (this.currentPlanet === 1) {
				if (this.savedMiniLevel === 4) {
					// updateMiniLevel(this.savedMiniLevel);
					// ////this.tabletNotification.setVisible(false);

					// this.tabletButton.input.enabled = false;

					console.log("Zoom out!!!!!!!!!!!!!!!")
					if (this.zoomOutOverlay) {
						this.zoomOutOverlay.remove()
					}
					if (side === "left") {
						this.leftScaleUpButton.input.enabled = false
						this.leftScaleUpButton.setAlpha(0.5)
						this.backButton.input.enabled = false
						this.backButton.setAlpha(0.5)
						this.frontButton.input.enabled = false
						this.frontButton.setAlpha(0.5)
					} else {
						this.rightScaleUpButton.input.enabled = false
						this.rightScaleUpButton.setAlpha(0.5)
					}
					////this.tabletNotification.setVisible(true)
					playNotificationAnimation(this, {
						xPos: this.tabletButton.x + 40 * this.scaleFactor,
						yPos: this.tabletButton.y - 40 * this.scaleFactor
					})
					this.tabletButton.input.enabled = true
					this.tabletButton.setAlpha(1)
					//displayIndicator(this, this.tabletButton.x, this.tabletButton.y);
					displayIndicator(
						this,
						this.tabletButton.x,
						this.tabletButton.y,
						1,
						"tabletIndicator",
					)
					displayInstructions(
						this,
						"Your tablet has a new notification.\nPlease press it.",
						14,
						300,
						60,
					)
				}
				if (this.savedMiniLevel === 5) {



					// console.log("Zoom out!!!!!!!!!!!!!!!")
					// ////this.tabletNotification.setVisible(true);
					// this.tabletButton.input.enabled = true;
					// displayIndicator(this, item.x - this.gameW, item.y);
					// displayInstructions(
					// 	this,
					// 	"This is Tube 1, one of your creature care stations.\nYou’ll feed and observe your new alien friends right here.",
					// 	12,
					// 	500,
					// 	60,
					// )
				}
				if (this.savedMiniLevel >= 9) {
					console.log("Finally Closed")

					if (side === "left") {
						this.leftScaleUpButton.input.enabled = false
						this.leftScaleUpButton.setAlpha(0.5)
					} else {
						this.rightScaleUpButton.input.enabled = false
						this.rightScaleUpButton.setAlpha(0.5)
					}

					//////this.tabletNotification.setVisible(true)
				}
				if (this.savedMiniLevel === 11) {
					handleGameProgressUpdate(this)
				}
			}

			if (this.currentPlanet === 2) {
				console.log("Planet 2 Scale Out Minilevel = " + this.savedMiniLevel)

				if (this.savedMiniLevel === 5) {
					// updateMiniLevel(this.savedMiniLevel);
					// ////this.tabletNotification.setVisible(false);
					// this.tabletButton.input.enabled = false;

					console.log("Zoom out!!!!!!!!!!!!!!!")

					if (side === "left") {
						this.leftScaleUpButton.input.enabled = false
						this.leftScaleUpButton.setAlpha(0.5)
					} else {
						//this.rightScaleUpButton.input.enabled = false
						//this.rightScaleUpButton.setAlpha(0.5)
						console.log()
					}

					////this.tabletNotification.setVisible(true)
					this.tabletButton.input.enabled = true
					this.tabletButton.setAlpha(1)

					// this.fetchCreatureButton = this.add
					// 	.image(this.gameW / 2 + this.gameW, this.gameH / 2, "saveBtn")
					// 	.setScale(this.scaleFactor * 1.5)
					// 	.setOrigin(0.5)
					// 	.setInteractive()
					// this.fetchCreatureText = this.add
					// 	.text(
					// 		this.fetchCreatureButton.x,
					// 		this.fetchCreatureButton.y - 10 * this.scaleFactor,
					// 		"FETCH\nCREATURE 3",
					// 		{
					// 			fontFamily: "Gluten",
					// 			fontSize: this.fontSize + 1 * this.scaleFactor,
					// 			color: "#fff",
					// 			align: "center",
					// 			fontWeight: "700",
					// 			fontStyle: "bold",
					// 			resolution: 2,
					// 		},
					// 	)
					// 	.setOrigin(0.5)

					// this.cockpitContainer.add(this.fetchCreatureButton)
					// this.cockpitContainer.add(this.fetchCreatureText)

					// this.fetchCreatureButton.on(
					// 	"pointerdown",
					// 	() => {
					// 		playUISound(this, this.soundManager, "Subtle click 1", 0.25)

					// 		destroyTooltip(this)

					// 		this.fetchCreatureButton.setVisible(false)
					// 		this.fetchCreatureText.setVisible(false)
					// 		if (this.savedMiniLevel >= 13) {
					// 			this.leftScaleUpButton.input.enabled = true
					// 			this.leftScaleUpButton.setAlpha(1)
					// 		}

					// 		this.creatureTubeL.setVisible(true)
					// 		this.creatureTubeL.setTexture("creature05_hungry")

					// 		const prefix = "L"
					// 		this.creatureTubeL.y -= 25 * this.scaleFactor

					// 		this[`${prefix}FoodTrayItems`].getChildren().forEach((item) => {
					// 			//item.setVisible(false)
					// 			item.setAlpha(0.5)
					// 			item.input.enabled = false
					// 		})

					// 		this.fetchCreatureBool = true
					// 	},
					// 	this,
					// )
					// displayInstructions(
					// 	this,
					// 	"This is Tube 1, one of your creature care stations.\nYou’ll feed and observe your new alien friends right here.",
					// 	12,
					// 	500,
					// 	60,
					// )
					console.log("This is your first first")
					displayInstructions(
						this,
						"This creature still needs to be treated",
						12,
						400,
						60,
					)
					this.leftScaleUpButton.setVisible(true)
					this.leftScaleUpButton.setAlpha(1)
					this.leftScaleUpButton.input.enabled = true

					if (this.currentPage === 1) {
						// displayTooltip(this, {
						// 	xPos: this.fetchCreatureButton.x - this.gameW,
						// 	yPos: this.fetchCreatureButton.y + 70 * this.scaleFactor,
						// 	type: "fetchTip",
						// 	scale: 1,
						// 	text: "Click this button to bring in your third creature,\nor head to Tube 2 to care for your second one.\nJust be sure all creatures get the care they need\nin order to complete your mission!",
						// 	fontScale: -8,
						// 	xTextOffset: 0,
						// 	yTextOffset: 5,
						// 	wrapWidth: 1.1,
						// })

						this.creatureLoadingImage = this.add.image(this.gameW / 2, this.gameH / 2, "creatureLoading").setName("CreatureLoading").setScale(this.scaleFactor / 3)
						//this.fetchCreatureButton.setVisible(false)
						//this.fetchCreatureText.setVisible(false)
						this.leftScaleUpButton.setVisible(false)

						displayInstructions(
							this,
							"Your tablet has a new notification.\nPlease press it.",
							12,
							350,
							70,
						)

						playNotificationAnimation(this, {
							xPos: this.tabletButton.x + 40 * this.scaleFactor,
							yPos: this.tabletButton.y - 40 * this.scaleFactor
						})
					}
				}
				if (this.savedMiniLevel === 9) {
					console.log("Finally Closed")
					if (side === "left") {
						this.leftScaleUpButton.input.enabled = false
						this.leftScaleUpButton.setAlpha(0.5)
					} else {
						this.rightScaleUpButton.input.enabled = false
						this.rightScaleUpButton.setAlpha(0.5)
					}
					////this.tabletNotification.setVisible(true)
				}
				if (this.savedMiniLevel === 11) {
					console.log("Check here!!!!")

					if (side === "left") {
						this.leftScaleUpButton.input.enabled = false
						this.leftScaleUpButton.setAlpha(0.5)
					} else {
						this.rightScaleUpButton.input.enabled = false
						this.rightScaleUpButton.setAlpha(0.5)
					}

					if (this.fetchCreatureBool) {
						this.leftScaleUpButton.input.enabled = true

						this.leftScaleUpButton.setAlpha(1)
						this.taskHeader.setVisible(false)
					}

					console.log("Instructions after scale out 1")
					handleGameProgressUpdate(this)
				}
				if (this.savedMiniLevel === 13) {
					this.rightScaleUpButton.input.enabled = false
					this.rightScaleUpButton.setAlpha(0.5)

					if (this.notificationBell) {
						this.notificationBell.destroy()
					}
					this.creature3Panel()
					// displayInstructions(
					// 	this,
					// 	"Creature 3 is still waiting! Move on to Tube 1 to care for it!",
					// 	12,
					// 	450,
					// 	60,
					// )

					// displayInstructions(
					// 	this,
					// 	"Your tablet has a new notification.\nPlease press it.",
					// 	14,
					// 	300,
					// 	60,
					// )
					console.log("Instructions after scale out 2")
					//destroyInstructions(this)

					const prefix = "L"

					this[`${prefix}FoodTrayItems`].getChildren().forEach((item) => {
						//item.setVisible(false)
						item.setAlpha(0.5)
						item.input.enabled = false
					})
				}
				if (this.savedMiniLevel === 17) {
					this.leftScaleUpButton.input.enabled = false
					this.leftScaleUpButton.setAlpha(0.5)

					this.newMissionCompletePanel()
				}
			}
			if (this.currentPlanet === 3) {
				if (this.savedMiniLevel === 9) {
					console.log("Zoom out!!!!!!!!!!!!!!!")



					displayInstructions(
						this,
						"Press the left and right arrow buttons to go to the next creature",
						14,
						500,
						60,
					)

					if (side === "left") {
						this.leftScaleUpButton.input.enabled = false
						this.leftScaleUpButton.setAlpha(0.5)
					} else {
						this.rightScaleUpButton.input.enabled = true
						this.rightScaleUpButton.setAlpha(1)
					}

					// this.fetchCreatureButton = this.add
					// 	.image(this.gameW / 2 + this.gameW, this.gameH / 2, "saveBtn")
					// 	.setScale(this.scaleFactor * 1.5)
					// 	.setOrigin(0.5)
					// 	.setInteractive()
					// this.fetchCreatureText = this.add
					// 	.text(
					// 		this.fetchCreatureButton.x,
					// 		this.fetchCreatureButton.y - 10 * this.scaleFactor,
					// 		"FETCH\nCREATURE 3",
					// 		{
					// 			fontFamily: "Gluten",
					// 			fontSize: this.fontSize + 1 * this.scaleFactor,
					// 			color: "#fff",
					// 			align: "center",
					// 			fontWeight: "700",
					// 			fontStyle: "bold",
					// 			resolution: 2,
					// 		},
					// 	)
					// 	.setOrigin(0.5)

					// this.cockpitContainer.add(this.fetchCreatureButton)
					// this.cockpitContainer.add(this.fetchCreatureText)

					if (this.currentPage === 1) {
						// displayTooltip(this, {
						// 	xPos: this.fetchCreatureButton.x - this.gameW,
						// 	yPos: this.fetchCreatureButton.y + 70 * this.scaleFactor,
						// 	type: "fetchTip",
						// 	scale: 1,
						// 	text: "Click this button to bring in your third creature,\nor head to Tube 2 to care for your second one.\nJust be sure all creatures get the care they need\nin order to complete your mission!",
						// 	fontScale: -8,
						// 	xTextOffset: 0,
						// 	yTextOffset: 5,
						// 	wrapWidth: 1.1,
						// })

						this.creatureLoadingImage = this.add.image(this.gameW / 2, this.gameH / 2, "creatureLoading").setName("CreatureLoading").setScale(this.scaleFactor / 3)
						//this.fetchCreatureButton.setVisible(false)
						//this.fetchCreatureText.setVisible(false)
						this.leftScaleUpButton.setVisible(false)

						// displayInstructions(
						// 	this,
						// 	"Your tablet has a new notification.\nPlease press it.",
						// 	12,
						// 	350,
						// 	70,
						// )

						playNotificationAnimation(this, {
							xPos: this.tabletButton.x + 40 * this.scaleFactor,
							yPos: this.tabletButton.y - 40 * this.scaleFactor
						})
					}

					
					console.log("This is your second first")
					// displayInstructions(
					// 	this,
					// 	"This is your first creature! Let's treat it!",
					// 	12,
					// 	400,
					// 	60,
					// )
					
					handleGameProgressUpdate(this)
					displayInstructions(
						this,
						"Press the left and right arrow buttons to go to the next creature",
						14,
						500,
						60,
					)
					this.loadSavedData()
					let alertsOpened = this.alertsOpened
					console.log("Alerts opened", alertsOpened)

					let allAlerts = ["robotAlert"]

					let unopenedAlerts = allAlerts.filter((alert) => !alertsOpened[alert])

					if (unopenedAlerts.length === 0) {
						console.log("Proceed to scanning")
						//this.tabletNotification.setVisible(false)
						if (this.notificationBell) {
							this.notificationBell.destroy()
						}
					} else {
						console.log("Unopened alerts blocking", unopenedAlerts)
						//this.tabletNotification.setVisible(true)
						playNotificationAnimation(this, {
							xPos: this.tabletButton.x + 40 * this.scaleFactor,
							yPos: this.tabletButton.y - 40 * this.scaleFactor
						})
					}
				}

				if (this.savedMiniLevel === 16) {
					console.log("Zoom out!!!!!!!!!!!!!!!")

					// displayInstructions(
					// 	this,
					// 	"Creature 3 is still waiting! Move on to Tube 1 to care for it!",
					// 	12,
					// 	450,
					// 	60,
					// )
					destroyInstructions(this)
					this.creature3Panel()
					if (side === "left") {
						//Push checker
						// this.leftScaleUpButton.input.enabled = false
						// this.leftScaleUpButton.setAlpha(0.5)
					} else {
						this.rightScaleUpButton.input.enabled = false
						this.rightScaleUpButton.setAlpha(0.5)
					}
				}
				if (this.savedMiniLevel === 23) {
					console.log("Zoom out Last!!!!!!!!!!!!!!!")

					if (side === "left") {
						//Push checker
						this.leftScaleUpButton.input.enabled = false
						this.leftScaleUpButton.setAlpha(0.5)
					} else {
						this.rightScaleUpButton.input.enabled = false
						this.rightScaleUpButton.setAlpha(0.5)
					}
					//this.handleMissionComplete()
					this.newMissionCompletePanel()
				}
			}
		}
	}

	moveCockpit(direction) {
		if (!this.tutorialComplete) {
			if (this.tutorialStep == 5) {
				this.step04Overlay.remove()
				this.step04Tip.destroy()
				this.step04TipText.destroy()
				destroyTutorialHand(this)
			}
			if (this.tutorialStep == 6) {
				this.step06Overlay.remove()
				this.step06Tip.destroy()
				this.step06TipText.destroy()
				destroyTutorialHand(this)
			}
		}

		destroyTutorialHand(this)

		playUISound(this, this.soundManager, "Subtle click 1", 0.25)
		if (!this.canClickBool) return
		this.canClickBool = false

		// Update current page
		this.currentPage = (this.currentPage - direction) % this.totalPages
		if (this.currentPage < 0) this.currentPage = this.totalPages - 1

		// Calculate new position
		const newX = this.cockpitContainer.x + direction * this.moveDistance

		// Update UI based on the new page
		this.updateButtonVisibility()

		// Animate the movement
		this.tweens.add({
			targets: this.cockpitContainer,
			x: newX,
			duration: 1000,
			ease: "Cubic",
			onComplete: () => {
				this.handleLoop()
				this.canClickBool = true
				if (!this.tutorialComplete) {
					if (this.tutorialStep == 5) {
						console.log("Its already Step5!!!!!!!!!!!!!!!!!!!")
						this.setupNewTutorialModeStory()
					}
					if (this.tutorialStep == 6) {
						this.setupNewTutorialModeStory()
					}
				}
			},
		})
	}

	updateButtonVisibility() {
		this.loadSavedData()
		console.log("Checking Mini LEVEL " + this.savedMiniLevel)

		if (this.currentPlanet === 1 && !this.tutorialComplete) {
			this.leftScaleUpButton.setVisible(false)
			return
		}

		if (this.currentPlanet === 2 && this.savedMiniLevel === 5) {
			if (this.currentPage === 1) {
				this.creatureLoadingImage.setVisible(true)
			}
			else {
				this.creatureLoadingImage.setVisible(false)
			}
		}
		if (this.currentPlanet === 3 && this.savedMiniLevel === 9) {
			if (this.currentPage === 1) {
				this.creatureLoadingImage.setVisible(true)
			}
			else {
				this.creatureLoadingImage.setVisible(false)
			}
		}
		//DEBUG
		// if (this.savedMiniLevel === 9) {
		// 	console.log("REMEMBER TO REMOVE!!!")
		// 	this.rightScaleUpButton.input.enabled = true
		// 	this.rightScaleUpButton.setAlpha(1)
		// }
		// Handle navigation instructions
		this.updateNavigationInstructions()

		if (this.currentPlanet === 3 && this.savedMiniLevel === 23) {
			this.hideAllFoodTaskGrids("R")
			this.rightNameTag.setVisible(false)
			this.hideFoodTaskElementsR()
		}

		// Handle scale up buttons
		this.tweens.add({
			targets: this.leftScaleUpButton,
			scale: this.currentPage === 1 ? this.scaleUpButtonScale * 0.5 : 0,
			duration: this.currentPage === 1 ? 500 : 10,
			ease: "Back.Out",
			delay: this.currentPage === 1 ? 500 : 0,
		})

		this.tweens.add({
			targets: this.rightScaleUpButton,
			scale: this.currentPage === 3 ? this.scaleUpButtonScale * 0.5 : 0,
			duration: this.currentPage === 3 ? 500 : 10,
			ease: "Back.Out",
			delay: this.currentPage === 3 ? 500 : 0,
		})
	}

	// Define reusable messages and instructions - moved outside the function
	static MESSAGES = {
		welcome:
			"Welcome to the cockpit, Medinaut!\nPress the left and right arrow buttons to look around your ship",
		lookAround:
			"Press the left and right arrow buttons to go to the next creature",
		tube1:
			"This is your first creature! Let's treat it!",
		tube2:
			"This creature still  needs to be treated",
		// hatch:
		// 	"Here is the main hatch—your entry and exit point from the spaceship.\nThere’s nothing to do here for now, but it’s how Medinauts head out when missions take them beyond the ship.",
		hatch:
			"Press the left and right arrow buttons to go to the next creature",
		waitingCreature2:
			"Press the left and right arrow buttons to go to the next creature",
		missionComplete:
			"Press the button to go!",
		planetMissionComplete:
			"This planet's mission is complete! You've cared for 2 creatures and earned fuel.\nGo to the cockpit to get ready for takeoff.",
		checkAlertsAndEmails:
			"Please check your alerts and emails before proceeding.",
		checkAlerts: "Please check your alerts before proceeding.",
		checkEmails: "Please check your emails before proceeding.",
	}

	static TOOLTIPS = {
		fuelGauge: {
			position: "Left",
			message:
				"Your Fuel Gauge needs to be full before leaving\nthis planet so keep an eye on it!",
			fontSize: 12,
		},
		tubeButton: {
			position: "Down",
			message: "Press the [b]‘INSPECT CREATURE’[/b] button\nto start treatment",
			fontSize: 12,
		},
		tubeButtonShort: {
			position: "Down",
			message: "Click to take a closer look at your creature",
			fontSize: 14,
		},
	}

	updateNavigationInstructions() {
		// Get current state
		const planet = this.currentPlanet
		const miniLevel = this.savedMiniLevel
		const page = this.currentPage

		// Always start by removing any existing tooltips

		if (this.currentPlanet === 1 && this.savedMiniLevel === 11) {
			console.log("Not destrpying tooltip")
		} else {
			destroyTooltip(this)
		}

		if (this.currentPlanet === 3 && this.savedMiniLevel === 16) {
			this.leftScaleUpButton.input.enabled = true
			this.leftScaleUpButton.setAlpha(1)
			this.taskHeader.setVisible(false)
			this.taskHeaderText.setVisible(false)
		}

		// CHECK FOR MISSION COMPLETE STATES FIRST (applies to any page)
		if (this.isMissionComplete(planet, miniLevel)) {
			return this.handleMissionComplete()
		}

		// Handle page-specific instructions
		switch (page) {
			case 0:
			case 4:
				destroyIndicator(this)
				this.handleCockpitView(planet, miniLevel)
				break
			case 1:
				destroyIndicator(this)
				this.handleTube1View(planet, miniLevel)
				break
			case 2:
				destroyIndicator(this)
				this.handleHatchView(planet, miniLevel)
				break
			case 3:
				destroyIndicator(this)
				this.handleTube2View()
				break
		}
	}
	//(planet === 3 && miniLevel === 23
	// Helper method to check if mission is complete
	isMissionComplete(planet, miniLevel) {
		return (
			(planet === 2 && miniLevel === 17) ||
			(planet === 3 && miniLevel === 23)
		)
	}

	// Handle mission complete logic
	handleMissionComplete() {
		let planet3Message =
			"Your fuel tank is full! Your mission on Emberon is complete, and you’re cleared for takeoff.\nWhere will this adventure take you next?"
		displayInstructions(
			this,
			this.currentPlanet === 3
				? this.constructor.MESSAGES.missionComplete
				: this.constructor.MESSAGES.missionComplete,
			12,
			300,
			60,
		)

		this.savedUserData = checkLocalSavedData()
		this.alertsOpened = this.savedUserData?.alertsOpened || {}
		this.emailsOpened = this.savedUserData?.emailsOpened || {}
		let alertsOpened = this.alertsOpened
		let emailsOpened = this.emailsOpened

		console.log("Alerts opened", alertsOpened)
		console.log("Emails opened", emailsOpened)

		let requiredAlerts = []
		let requiredEmails = 0
		if (this.currentPlanet === 1) {
			requiredAlerts = ["facialScan"]
			requiredEmails = 2
		} else if (this.currentPlanet === 2) {
			requiredAlerts = ["securityCheck", "restartDevice"]
			requiredEmails = 2
		} else if (this.currentPlanet === 3) {
			requiredAlerts = ["otpAlert", "reconnectDevice", "robotAlert"]
			requiredEmails = 4
		}

		let allAlertsOpened = requiredAlerts.every((alert) => alertsOpened[alert])
		let allEmailsOpened = emailsOpened === requiredEmails

		if (allAlertsOpened && allEmailsOpened) {
			console.log("All alerts and emails already opened")

			if (this.currentPage === 0 || this.currentPage === 4) {
				this.disableNavigationButtons()
				this.showLaunchButton()
			}
			this.tabletButton.input.enabled = false
			this.tabletButton.setAlpha(0.5)
			//this.tabletNotification.setVisible(false)
			//removeNotificationBell(this)
			if (this.notificationBell) {
				this.notificationBell.destroy()
			}
		} else {
			const unopenedAlert = requiredAlerts.find((key) => !alertsOpened[key])
			console.log("Unopened alert", unopenedAlert)
			console.log(`Emails opened: ${emailsOpened}/${requiredEmails}`)

			if (this.currentPage === 0 || this.currentPage === 4) {
				this.disableNavigationButtons()
			}
			this.tabletButton.input.enabled = true
			this.tabletButton.setAlpha(1)
			//this.tabletNotification.setVisible(true)
			playNotificationAnimation(this, {
				xPos: this.tabletButton.x + 40 * this.scaleFactor,
				yPos: this.tabletButton.y - 40 * this.scaleFactor
			})

			// Show appropriate message based on what's missing
			let message = this.constructor.MESSAGES.checkAlerts
			if (!allAlertsOpened && !allEmailsOpened) {
				message = this.constructor.MESSAGES.checkAlertsAndEmails
			} else if (!allEmailsOpened) {
				message =
					this.constructor.MESSAGES.checkEmails ||
					this.constructor.MESSAGES.checkAlerts
			}

			displayInstructions(this, message, 12, 450, 60)
		}


		return true // Indicates we handled mission complete
	}

	// Handle cockpit view (pages 0 and 4)
	handleCockpitView(planet, miniLevel) {
		// New player welcome on planet 1
		if (planet === 1 && miniLevel === 0) {
			this.showWelcomeMessage()
			return
		}

		// Planet 1 completion
		if (planet === 1 && miniLevel === 13) {
			this.showPlanet1Completion()
			return
		}

		// Default cockpit instructions for planets 2 & 3
		if (planet > 1) {
			displayInstructions(
				this,
				this.constructor.MESSAGES.lookAround,
				14,
				500,
				60,
			)
		}
	}

	// Handle Tube 1 view (page 1)
	handleTube1View(planet, miniLevel) {
		// Special case: Creature 2 waiting
		if (miniLevel === 5) {
			displayInstructions(
				this,
				this.constructor.MESSAGES.waitingCreature2,
				12,
				400,
				60,
			)
			return
		}

		// Planet 1 mission complete
		if (planet === 1 && miniLevel === 13) {
			this.hideFoodTaskElements()
			displayInstructions(
				this,
				this.constructor.MESSAGES.planetMissionComplete,
				12,
				500,
				60,
			)
			return
		}

		// Default Tube 1 message
		displayInstructions(this, this.constructor.MESSAGES.tube1, 12, 400, 60)

		if (planet === 2 && miniLevel === 13 || planet === 3 && miniLevel === 16) {
			this.hideFoodTaskElements()
			displayInstructions(
				this,
				"This creature still needs to be treated",
				12,
				400,
				60,
			)
			this.leftScaleUpButton.setVisible(true)
			this.leftScaleUpButton.setAlpha(1)
			this.leftScaleUpButton.input.enabled = true

			this.creatureTubeL.setVisible(true)
			if (planet === 2) {
				this.creatureTubeL.setTexture("creature05_hungry")
			}
			else if (planet === 3) {
				this.creatureTubeL.setTexture("creature08_hungry")
			}
			const prefix = "L"
			this.creatureTubeL.y -= 25 * this.scaleFactor

			this[`${prefix}FoodTrayItems`].getChildren().forEach((item) => {
				//item.setVisible(false)
				item.setAlpha(0.5)
				item.input.enabled = false
			})

			this.fetchCreatureBool = true
		}



		// Add tooltip for new players
		if (miniLevel === 0) {
			this.showTubeButtonTooltip(planet)
		}
	}

	// Handle Hatch view (page 2)
	handleHatchView(planet, miniLevel) {
		displayInstructions(this, this.constructor.MESSAGES.hatch, 12, 400, 60)

		// Planet 1 mission complete
		if (planet === 1 && miniLevel === 13) {
			displayInstructions(
				this,
				this.constructor.MESSAGES.planetMissionComplete,
				12,
				500,
				60,
			)
		}
	}

	// Handle Tube 2 view (page 3)
	handleTube2View() {
		displayInstructions(this, this.constructor.MESSAGES.tube2, 12, 350, 60)
		if (this.currentPlanet === 1 && this.savedMiniLevel === 0) {
			destroyInstructions(this)
		}
		if (this.currentPlanet === 1 && this.savedMiniLevel === 0 ||
			this.currentPlanet === 2 && this.savedMiniLevel === 0 ||
			this.currentPlanet === 3 && this.savedMiniLevel === 0
		) {
			destroyInstructions(this)

			this.time.delayedCall(1000, () => {
				displayTooltip(this, {
					xPos: this.gameW / 2,
					yPos: this.gameH / 2 - 25 * this.scaleFactor,
					type: "finishOtherCreatureTip",
					scale: 1,
					text: "Finish the other creature first",
					fontScale: -8,
					xTextOffset: 0,
					yTextOffset: -8,
					wrapWidth: 1,
				})
				// displayIndicator(
				// 	this,
				// 	this.rightScaleUpButton.x - (this.gameW * 3.5) + 425 * this.scaleFactor,
				// 	this.rightScaleUpButton.y - 5 * this.scaleFactor,
				// 	2,
				// 	"buttonTip"
				// );

				// console.log("Displaying Tube Button Tooltip");
			});
		}

		if (this.currentPlanet === 2 && this.savedMiniLevel === 13) {
			this, rightScaleUpButton.setAlpha(1)
			this, rightScaleUpButton.input.enabled = true
		}
	}

	// Helper methods for common actions
	showWelcomeMessage() {
		displayInstructions(this, this.constructor.MESSAGES.welcome, 14, 500, 60)
		this.time.delayedCall(500, () => {
			// console.log("Displaying Fuel Gauge Tooltip")
			displayTooltip(this, {
				xPos: this.fuelGauge.x - 190 * this.scaleFactor,
				yPos: this.fuelGauge.y,
				type: "leftMediumTip",
				scale: 1,
				text: "This is your Fuel Gauge.\nIt needs to be full before leaving\nthis planet so keep an eye on it!",
				fontScale: -8,
				xTextOffset: 0,
				yTextOffset: 0,
				wrapWidth: 1,
			})
		})
	}

	showPlanet1Completion() {

		displayInstructions(
			this,
			"Press the button to go!",
			12,
			300,
			55,
		)

		this.time.delayedCall(1300, () => {
			displayTooltip(this, {
				xPos: this.fuelGauge.x,
				yPos: this.fuelGauge.y + 105 * this.scaleFactor,
				type: "initiateLiftOffTip",
				scale: 1,
				text: "Press to initiate liftoff!",
				fontScale: -8,
				xTextOffset: 0,
				yTextOffset: 4,
				wrapWidth: 0.9,
			})
		})

		if (this.currentPage === 0 || this.currentPage === 4) {
			this.showLaunchButton()
			this.disableNavigationButtons()
		}
	}

	showLaunchButton() {
		this.time.delayedCall(1300, () => {
			this.launchButton.setVisible(true)

			this.tweens.add({
				targets: this.launchButton,
				scale: this.scaleFactor * 0.55,
				duration: 800,
				ease: 'Sine.easeInOut',
				yoyo: true,
				repeat: -1
			})

			if (this.currentPlanet === 1) {
				displayTooltip(this, {
					xPos: this.launchButton.x,
					yPos: this.launchButton.y + 50 * this.scaleFactor,
					type: "initiateLiftOffTip",
					scale: 1,
					text: "Press to initiate liftoff!",
					fontScale: -8,
					xTextOffset: 1,
					yTextOffset: 7,
				})
			}
		})
	}

	disableNavigationButtons() {
		this.frontButton.input.enabled = false
		this.frontButton.setAlpha(0.5)
		this.backButton.input.enabled = false
		this.backButton.setAlpha(0.5)
	}

	hideFoodTaskElements() {
		this.hideAllFoodTaskGrids("L")
		this.LFoodTaskHolder.setVisible(false)
		this.taskHeader.setVisible(false)
		this.taskHeaderText.setVisible(false)
	}

	hideFoodTaskElementsR() {
		this.hideAllFoodTaskGrids("R")
		this.RFoodTaskHolder.setVisible(false)
		this.RTaskHeader.setVisible(false)
		this.RTaskHeaderText.setVisible(false)
		this.RTaskGrid.setVisible(false)
	}

	showTubeButtonTooltip(planet) {
		if (this.currentPlanet === 3) return

		this.time.delayedCall(500, () => {
			const tooltipConfig =
				planet === 1
					? this.constructor.TOOLTIPS.tubeButton
					: this.constructor.TOOLTIPS.tubeButton

			displayTooltip(this, {
				xPos: this.leftScaleUpButton.x - this.gameW - 1 * this.scaleFactor,
				yPos: this.leftScaleUpButton.y + 50 * this.scaleFactor,
				type: planet === 1 ? "downMediumTip" : "downMediumTip",
				scale: 1.3,
				text: tooltipConfig.message,
				fontScale: -8,
				xTextOffset: 1,
				yTextOffset: 6,
				wrapWidth: 0.9,
			})

			if (this.currentPlanet === 1) {
				displayTutorialHand(this, {
					xPos: this.gameW / 2 - 160 * this.scaleFactor,
					yPos: this.leftScaleUpButton.y - 50 * this.scaleFactor,
					rotation: 110,
				})

				const overlay = phaserOverlay(this);

				const button = this.leftScaleUpButton

				overlay.setTargetByCoords(
					this.gameW / 2 - button.width * this.scaleFactor * 0.5 * 0.5,
					this.gameH / 2 - button.height * this.scaleFactor * 0.5 * 0.5 + 12 * this.scaleFactor,
					button.width * this.scaleFactor * 0.5,
					button.height * this.scaleFactor * 0.5,
					15
				)

				this.lScaleOverlayReference = overlay

				overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.instructionBgContainer, this.instructionBgCenter, this.instructionBgRight, this.instructionText, this.tutorialHand])
			}
		})
	}

	handleLoop() {
		// Get current position
		const xPos = this.cockpitContainer.x

		// Handle looping logic
		if (xPos <= -this.moveDistance * 4) {
			// Reset to start if we've gone too far right
			this.cockpitContainer.setX(0)
		} else if (xPos >= this.moveDistance) {
			// Reset to end if we've gone too far left
			this.cockpitContainer.setX(-this.moveDistance * 3)
		}
	}

	feedingCompleted(index, side) {
		this.tabletButton.input.enabled = true

		const prefix = side === "left" ? "L" : "R"
		const tube = side === "left" ? this.creatureTubeL : this.creatureTubeR

		// Update creature texture
		if (side === "left") {
			// console.log("Feeding Completed Saved Mini Level: " + this.savedMiniLevel)
			if (this.currentPlanet === 2) {
				if (this.savedMiniLevel === 15) {
					tube.setTexture(`creature0${this.currentLeftCreature}_fed`)
				} else {
					tube.setTexture(`creature0${this.currentLeftCreature}_fed`)
				}
			} else if (this.currentPlanet === 3) {
				if (this.savedMiniLevel === 21) {
					tube.setTexture(`creature0${this.currentLeftCreature}_fed`)
				} else {
					tube.setTexture(`creature0${this.currentLeftCreature}_fed`)
				}
			} else {
				tube.setTexture(`creature0${this.currentLeftCreature}_fed`)
			}
		} else {
			tube.setTexture(`creature0${this.currentRightCreature}_fed`)
		}

		this.changeTaskTexture(3, "taskActive", side)
		//this[`${prefix}FoodTray`].setVisible(false)
		this[`${prefix}FoodTrayItems`].getChildren().forEach((item) => {
			//item.setVisible(false)
			item.setAlpha(0.5)
			item.input.enabled = false
		})

		// Reset feeding tracking for this side
		const trackingKey = `${prefix}FeedingData`
		if (this[trackingKey]) {
			Object.keys(this[trackingKey].foodGrids).forEach((key) => {
				this[trackingKey].foodGrids[key].currentFed = 0
				this[trackingKey].foodGrids[key].isComplete = false
			})
			this[trackingKey].allComplete = false
		}

		// Only destroy indicator if it exists (applicable to any side)
		if (this.indicator) {
			this.indicator.destroy()
		}

		this.tabletButton.setVisible(true)
		this.tabletButton.setAlpha(1)
		//this.tabletNotification.setVisible(true)
		playNotificationAnimation(this, {
			xPos: this.tabletButton.x + 40 * this.scaleFactor,
			yPos: this.tabletButton.y - 40 * this.scaleFactor
		})
		// if (this.currentPlanet === 3 && this.savedMiniLevel === 7) {
		// 	//this.tabletNotification.setVisible(false)
		// }

		// Get saved data
		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 0
		this.alertsOpened = this.savedUserData?.alertsOpened || {}
		// console.log(`Before Feeding MiniLevel for ${side}: ${this.savedMiniLevel}`)

		if (this.currentPlanet === 1) {
			if (this.savedMiniLevel === 2) {
				displayInstructions(
					this,
					"Well done!",
					12,
					200,
					60,
				)
				if (this.feedOverlayRef) {
					this.feedOverlayRef.remove()
				}
				if (this.tutorialHand) {
					this.tutorialHand.destroy()
				}

				displayTutorialHand(this, {
					xPos: this.tabletButton.x + 100 * this.scaleFactor,
					yPos: this.tabletButton.y - 100 * this.scaleFactor,
					rotation: -135,
				})
				//displayTooltip(this, this.tabletButton.x + 170 * this.scaleFactor, this.tabletButton.y + 2 * this.scaleFactor, 'medium', 'Right', 'You have a new notification on your Tablet.Press to find out more.', 17);
				this.tooltipText.destroy()
				displayTooltip(this, {
					xPos: this.tabletButton.x + 150 * this.scaleFactor,
					yPos: this.tabletButton.y + 2 * this.scaleFactor,
					type: "thisIsYourTabletTip",
					scale: 1.2,
					text: "[b]Record[/b] how much food\nwas given in the [b]‘Activity Log’[/b]",
					fontScale: -8,
					xTextOffset: 13,
					yTextOffset: -6,
					//wrapWidth: 1.15
				})
				if (this.feedTrayOverlayRef) {
					this.feedTrayOverlayRef.remove()
				}
				this.displayOverlay()
				displayIndicator(
					this,
					this.tabletButton.x,
					this.tabletButton.y - 8 * this.scaleFactor,
					1.2,
					"tabletIndicator",
				)
			}
			if (this.savedMiniLevel === 8) {
				displayInstructions(
					this,
					"Well done!",
					12,
					200,
					60,
				)
				//displayTooltip(this, this.tabletButton.x + 170 * this.scaleFactor, this.tabletButton.y + 2 * this.scaleFactor, 'small', 'Right', 'Don’t forget to log the food given in the Activity Log', 14);
				displayTooltip(this, {
					xPos: this.tabletButton.x + 170 * this.scaleFactor,
					yPos: this.tabletButton.y + 2 * this.scaleFactor,
					type: "tabletTip",
					scale: 1.2,
					text: "[b]Record[/b] how much food\nwas given in the [b]Activity Log[/b]",
					fontScale: -8,
					xTextOffset: 3,
					yTextOffset: 1,
					wrapWidth: 0.8,
				})
				displayIndicator(
					this,
					this.tabletButton.x,
					this.tabletButton.y - 8 * this.scaleFactor,
					1.2,
					"tabletIndicator",
				)
				displayTutorialHand(this, {
					xPos: this.tabletButton.x + 100 * this.scaleFactor,
					yPos: this.tabletButton.y - 100 * this.scaleFactor,
					rotation: -135,
				})
			}
		}

		if (this.currentPlanet === 2) {
			if (this.savedMiniLevel === 2) {
				displayInstructions(
					this,
					"Well done!",
					12,
					200,
					60,
				)
				//displayIndicator(this, this.tabletButton.x, this.tabletButton.y + 10 * this.scaleFactor, 1.6 * this.scaleFactor, 1.6 * this.scaleFactor);
				displayIndicator(
					this,
					this.tabletButton.x,
					this.tabletButton.y - 8 * this.scaleFactor,
					1.2,
					"tabletIndicator",
				)

				displayTutorialHand(this, {
					xPos: this.tabletButton.x + 100 * this.scaleFactor,
					yPos: this.tabletButton.y - 100 * this.scaleFactor,
					rotation: -135,
				})
			}
			if (this.savedMiniLevel === 8) {
				displayInstructions(
					this,
					"Well done!",
					12,
					200,
					60,
				)
				displayTooltip(
					this,
					this.tabletButton.x + 170 * this.scaleFactor,
					this.tabletButton.y + 2 * this.scaleFactor,
					"small",
					"Right",
					"Don’t forget to log the food given in the Activity Log",
					14,
				)
				displayTutorialHand(this, {
					xPos: this.tabletButton.x + 100 * this.scaleFactor,
					yPos: this.tabletButton.y - 100 * this.scaleFactor,
					rotation: -135,
				})
			}
			if (this.savedMiniLevel === 15) {
				displayInstructions(
					this,
					"Well done!",
					12,
					200,
					60,
				)
				//displayTooltip(this, this.tabletButton.x + 170 * this.scaleFactor, this.tabletButton.y + 2 * this.scaleFactor, 'small', 'Right', 'Don’t forget to log the food given in the Activity Log', 14);
			}
		}

		if (this.currentPlanet === 3) {
			if (this.savedMiniLevel === 20) {
				displayInstructions(
					this,
					"Well done!",
					12,
					200,
					60,
				)
			}
		}

		updateMiniLevel(this.savedMiniLevel)
		// console.log(
		// 	"After Feeding MiniLevel for " + side + ": " + this.savedMiniLevel,
		// )
		if (this.currentPlanet === 3 && this.savedMiniLevel === 5) {
			// console.log("Handle Level Stuff")
			handleGameProgressUpdate(this)
		}
		if (this.currentPlanet === 3 && this.savedMiniLevel === 13) {
			// console.log("Handle Level Stuff")
			handleGameProgressUpdate(this)
		}
	}

	hideFeedingTray() {
		if (this.LFoodTray) {
			this.LFoodTray.setVisible(false)
			if (this.LFoodTrayItems) {
				this.LFoodTrayItems.getChildren().forEach((item) => {
					item.setVisible(false)
				})
			}
		}

		if (this.RFoodTray) {
			this.RFoodTray.setVisible(false)
			if (this.RFoodTrayItems) {
				this.RFoodTrayItems.getChildren().forEach((item) => {
					item.setVisible(false)
				})
			}
		}
	}

	async sendMilestoneAPI(planet, currentCreature) {
		const milestoneMap = {
			1: {
				1: [
					"C3.3.7",
					"C2.2.1",
					"C3.3.1",
					"C3.3.5",
					"C1.5.5",
					"C2.5.1",
					"C3.1.2",
					"C3.3.2",
					"C3.2.3",
					"C3.1.1",
					"C4.2.2",
					"C4.2.3",
				],
				2: ["C3.3.8", "C3.2.1"],
			},

			2: {
				3: ["C3.3.4", "C1.4.2", "C3.1.3"],
				4: ["C3.2.2", "C3.3.6"],
				5: ["C1.9.1", "C2.1.3"],
			},

			3: {
				6: ["C2.1.4"],
				7: ["C4.2.1"],
			},
		}
		try {
			const codes = milestoneMap[planet]?.[currentCreature]
			if (codes && Array.isArray(codes)) {
				for (const code of codes) {
					// console.log(
					// 	`Recording milestone completion for code: ${code}\nfor user: ${this.userId}\ncurrent planet: ${planet}\ncurrent creature: ${currentCreature}`,
					// )
					await this.apiHandler.recordMilestoneCompletion(this.userId, code)
				}
			}
		} catch (error) {
			console.error("Error recording milestone(s):", error)
		}
	}

	dischargeFunctionality(side) {
		destroyIndicator(this)
		const sideKey = side === "left" ? "L" : "R"
		const currentSideKey = side === "left" ? "Left" : "Right"

		playUISound(this, this.soundManager, "spacething_teleporting", 0.25)
		playConfettiAnimation(this)

		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 0
		this.userId = this.savedUserData?.userID || 1
		//updateMiniLevel(this.savedMiniLevel);

		if (this.taskHeader02BackUp) {
			this.taskHeader02BackUp.setVisible(false)
		}

		if (this.currentPlanet === 1) {
			if (this.dischargeOverlayRef) {
				this.dischargeOverlayRef.remove()
			}
		}

		if (this.tutorialHand) {
			this.tutorialHand.destroy()
		}

		// @DESC: Discharge log progress to db
		handleGameProgressUpdate(this)
		const currentCreature = this[`current${currentSideKey}Creature`]
		const planet = this.currentPlanet

		this.sendMilestoneAPI(planet, currentCreature)

		if (side === "left") {
			this.leftNameTag.setVisible(false)
		} else {
			this.rightNameTag.setVisible(false)
		}

		console.log(
			"Discharge Functionality " +
			side +
			"Current Active Creature: " +
			currentCreature + " MiniLevel: " + this.savedMiniLevel
		)
		if (this.currentPlanet === 1 && this.savedMiniLevel === 4) {
			this.displayReturnOverlay()
			destroyInstructions(this)
		}
		if (this.currentPlanet === 3 && this.savedMiniLevel === 22) {
			destroyInstructions(this)
		}
		saveCreatureStatusLocally(currentCreature + 1, currentCreature)

		if (side === "left") {
			this.creatureTubeL.setVisible(false)
			this.taskHeaderText.setVisible(false)
			if (this.currentPlanet <= 2) {
				//this.LTaskHeaderText.setVisible(false);
				this.LFoodTaskHolder.setVisible(false)
				this.LTaskGrid.setVisible(false)
				this.hideAllFoodTaskGrids("L")
			} else {
				console.log("Hide All Food Task Grids")
				this.LFoodTaskHolder.setVisible(false)
				this.LTaskGrid.setVisible(false)
				this.hideAllFoodTaskGrids("L")
			}

			if (this.currentPlanet === 2 && this.savedMiniLevel === 5) {
				this.tabletButton.setAlpha(0.5)
				this.tabletButton.input.enabled = false
			}



			this.LTaskGrid.setVisible(false)
			this.LDischargeButton.setVisible(false)
			this.LDischargeText.setVisible(false)
			this.LFeedMeButton.setVisible(false)
			this.LFeedMeText.setVisible(false)
			this.LFedGroup.setVisible(false)

			this.rightScaleUpButton.setAlpha(1)

			this.leftScaleUpButton.setVisible(true)
			this.leftScaleUpButton.input.enabled = true
			this.leftScaleUpButton.setAlpha(1)

			this.rightScaleUpButton.setVisible(true)
		} else {
			console.log("Current Discharge Mini Level: " + this.savedMiniLevel)
			this.currentLeftCreature = this.currentRightCreature + 1
			this.currentLeftCreature = this.currentRightCreature + 1
			if (this.currentPlanet === 2) {
				this.leftNameTag.setTexture("skyRayTag")
				this.leftNameTag.setVisible(false)
				this.leftNameTag.setPosition(
					this.originalTagPosition.x,
					this.originalTagPosition.y,
				)
				this.leftTubeTag.setPosition(
					this.tubeTagOriginalPosition.x,
					this.tubeTagOriginalPosition.y,
				)
				this.createFoodTaskGrids("left")
			}
			if (this.currentPlanet === 3) {
				this.leftNameTag.setTexture("smothTag")
				this.leftNameTag.setVisible(false)
				this.leftNameTag.setPosition(
					this.originalTagPosition.x,
					this.originalTagPosition.y,
				)
				this.leftTubeTag.setPosition(
					this.tubeTagOriginalPosition.x,
					this.tubeTagOriginalPosition.y,
				)
				this.createFoodTaskGrids("left")
				this.hideAllFoodTaskGrids("L")
			}
			this.leftNameTag.setVisible(false)
			this.LFoodTaskHolder.setVisible(false)
			this.LTaskGrid.setVisible(false)

			this.creatureTubeR.setVisible(false)
			this.RTaskHeaderText.setVisible(false)
			if (this.currentPlanet <= 2) {
				//this.LTaskHeaderText.setVisible(false);
				this.RFoodTaskHolder.setVisible(false)
				this.RTaskGrid.setVisible(false)
				this.hideAllFoodTaskGrids("R")
			} else {
				this.RFoodTaskHolder.setVisible(false)
				this.RTaskGrid.setVisible(false)
				this.hideAllFoodTaskGrids("R")
			}
			this.RTaskGrid.setVisible(false)
			this.RDischargeButton.setVisible(false)
			this.RDischargeText.setVisible(false)
			this.RFeedMeButton.setVisible(false)
			this.RFeedMeText.setVisible(false)
			this.RFedGroup.setVisible(false)

			this.rightScaleUpButton.setVisible(true)
			this.rightScaleUpButton.input.enabled = true
			this.rightScaleUpButton.setAlpha(1)
			// console.log("Zoom Icon can show =====>")
			//this.leftScaleUpButton.setVisible(true)

			this.rightTubeCreature.setVisible(false)
		}
	}

	// ---- LEVEL PROGRESSION ----

	initializeBasedOnLevel() {
		if (this.currentPlanet === 1) {
			//this.setupTutorialModeStory()
			this.setupNewTutorialModeStory()
		} else {
			this.setupNormalMode()
		}
	}

	setupNewTutorialModeStory() {
		this.radar.setVisible(false)
		this.hideElements()

		let onboardingCompleted
		let savedUserData = checkLocalSavedData()
		onboardingCompleted = savedUserData.onboardingCompleted
		//DEBUG
		//onboardingCompleted = false
		//this.newMissionCompletePanel()
		//this.showLaunchButton()
		//return

		if (onboardingCompleted) {
			this.tutorialComplete = true
			this.frontButton.setVisible(false)
			this.backButton.setVisible(false)
			this.tabletButton.setVisible(false)
			step08(this)
		}
		else {
			if (this.tutorialStep == 0) {
				step01(this)
				console.log("step 4!!!!!!!!!!!!!!!!!!")
			}
			else if (this.tutorialStep == 5) {
				step05(this)
				console.log("step 5!!!!!!!!!!!!!!!!!!")
			}
			else if (this.tutorialStep == 6) {
				step07(this)
				console.log("step 6!!!!!!!!!!!!!!!!!!")
			}
		}


		function step01(scene) {

			const overlay = phaserOverlay(scene);

			const maskWidth = scene.gameW - 220 * scene.scaleFactor;
			const maskHeight = scene.gameH - 40 * scene.scaleFactor;

			overlay.setTargetByCoords(
				(scene.gameW / 2) - (maskWidth / 2),  // Center X minus half width
				(scene.gameH / 2) - (maskHeight / 2), // Center Y minus half height
				maskWidth,
				maskHeight
			);


			scene.frontButton.input.enabled = false
			scene.frontButton.setAlpha(0.5)
			scene.backButton.input.enabled = false
			scene.backButton.setAlpha(0.5)

			scene.tabletButton.setAlpha(0.5)
			scene.tabletButton.input.enabled = false

			let nextButton = scene.add.image(scene.gameW / 2, scene.gameH - 60 * scene.scaleFactor, "normalWideBtn").setScale(scene.scaleFactor * 0.5).setInteractive()
			nextButton.setInteractive()
			let nextText = scene.add.text(nextButton.x, nextButton.y - 5 * scene.scaleFactor, "NEXT", {
				fontSize: Math.round(scene.fontSize + 11 * scene.scaleFactor) + "px",
				fill: "#FFFFFF",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			})
				.setOrigin(0.5)
				.setDepth(2)

			displayTutorialHand(scene, {
				xPos: nextButton.x + 110 * scene.scaleFactor,
				yPos: nextButton.y - 50 * scene.scaleFactor,
				rotation: -120
			})

			let welcomeTip = scene.add.image(scene.gameW / 2, 80 * scene.scaleFactor, "welcomeTip").setScale(scene.scaleFactor * 0.5).setDepth(2)
			let welcomeText = scene.add.rexBBCodeText(
				// scene.gameW / 2 - 110 * scene.scaleFactor,
				// 60 * scene.scaleFactor,
				welcomeTip.x,
				welcomeTip.y,
				"[b]Welcome![/b]\nThis is your spaceship’s cockpit",
				{
					fontFamily: "Space Grotesk",
					fontSize: scene.fontSize - 6 * scene.scaleFactor,
					color: "#11044E",
					align: "center",
					//lineSpacing: 6,
					resolution: 2,
				},
			).setDepth(2).setOrigin(0.5)


			nextButton.on("pointerdown", () => {
				playUISound(scene, scene.soundManager, "Subtle click 1", 0.25)
				nextButton.destroy()
				nextText.destroy()
				welcomeTip.destroy()
				welcomeText.destroy()
				destroyTutorialHand(scene)
				overlay.remove()
				step02(scene)
				//step02.call(this)
			})

			animateElements([welcomeTip, welcomeText, nextButton, nextText], scene)
			// scene.time.delayedCall(2000, () => {
			// 	animateElements([nextButton, nextText, welcomeTip, welcomeText], scene);
			// })
		}

		function step02(scene) {
			const overlay = phaserOverlay(scene);

			const button = scene.fuelGauge

			overlay.setTargetByCoords(
				(button.x - (button.width * scene.scaleFactor * 0.5 / 2)),
				(button.y - (button.height * scene.scaleFactor * 0.5 / 2)),
				button.width * scene.scaleFactor * 0.5,
				button.height * scene.scaleFactor * 0.5,
				15
			)

			let nextButton = scene.add.image(scene.gameW / 2, scene.gameH - 60 * scene.scaleFactor, "normalWideBtn").setScale(scene.scaleFactor * 0.5).setInteractive()
			nextButton.setInteractive()
			let nextText = scene.add.text(nextButton.x, nextButton.y - 5 * scene.scaleFactor, "NEXT", {
				fontSize: Math.round(scene.fontSize + 11 * scene.scaleFactor) + "px",
				fill: "#FFFFFF",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			})
				.setOrigin(0.5)
				.setDepth(2)

			displayTutorialHand(scene, {
				xPos: nextButton.x + 110 * scene.scaleFactor,
				yPos: nextButton.y - 50 * scene.scaleFactor,
				rotation: -120
			})


			let fuelTip = scene.add.image(scene.fuelGauge.x - 180 * scene.scaleFactor, scene.fuelGauge.y, "fuelTip").setScale(scene.scaleFactor * 0.5).setDepth(2)
			let fuelText = scene.add.rexBBCodeText(
				// fuelTip.x / 2 + 20 * scene.scaleFactor,
				// fuelTip.y / 2 + 50 * scene.scaleFactor,
				// scene.fuelGauge.x - 280 * scene.scaleFactor,
				// scene.fuelGauge.y - 28 * scene.scaleFactor,
				fuelTip.x,
				fuelTip.y,
				"This is your [b]Fuel[/b].\nIt needs to be [b]full[/b] before you can\ntravel to the next planet.",
				{
					fontFamily: "Space Grotesk",
					fontSize: scene.fontSize - 8 * scene.scaleFactor,
					color: "#11044E",
					align: "center",
					//lineSpacing: 2,
					resolution: 2,
				},
			).setDepth(2).setOrigin(0.5)
			//overlay.setAboveOverlay(this.scanButton);
			overlay.setAboveOverlay([nextButton, nextText, scene.tutorialHand, fuelTip, fuelText]);

			nextButton.on("pointerdown", () => {
				playUISound(scene, scene.soundManager, "Subtle click 1", 0.25)
				nextButton.destroy()
				nextText.destroy()
				fuelTip.destroy()
				fuelText.destroy()
				destroyTutorialHand(scene)
				overlay.remove()
				step03(scene)
			})

			animateElements([fuelTip, fuelText, nextButton, nextText], scene)
		}

		function step03(scene) {
			const overlay = phaserOverlay(scene);

			const button = scene.radar

			overlay.setTargetByCoords(
				button.x - (button.width * scene.scaleFactor * 0.5 / 2) - 45 * scene.scaleFactor,
				button.y - (button.height * scene.scaleFactor * 0.5 / 2) - 17 * scene.scaleFactor,
				button.width * scene.scaleFactor * 0.5 + 90 * scene.scaleFactor,
				button.height * scene.scaleFactor * 0.5 + 35 * scene.scaleFactor,
				// button.width * 0.5 + 110 * scene.scaleFactor,
				// button.height * 0.5 + 55 * scene.scaleFactor,
				15
			)

			let nextButton = scene.add.image(scene.gameW / 2, scene.gameH - 60 * scene.scaleFactor, "normalWideBtn").setScale(scene.scaleFactor * 0.5).setInteractive()
			nextButton.setInteractive()
			let nextText = scene.add.text(nextButton.x, nextButton.y - 5 * scene.scaleFactor, "NEXT", {
				fontSize: Math.round(scene.fontSize + 11 * scene.scaleFactor) + "px",
				fill: "#FFFFFF",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			})
				.setOrigin(0.5)
				.setDepth(2)

			displayTutorialHand(scene, {
				xPos: nextButton.x + 110 * scene.scaleFactor,
				yPos: nextButton.y - 50 * scene.scaleFactor,
				rotation: -120
			})

			let radarTip = scene.add.image(scene.radar.x, scene.radar.y - 100 * scene.scaleFactor, "radarTip").setScale(scene.scaleFactor * 0.5)
			let radarText = scene.add.rexBBCodeText(
				// radarTip.x - 65 * scene.scaleFactor,
				// radarTip.y - 15 * scene.scaleFactor,
				radarTip.x,
				radarTip.y - 10 * scene.scaleFactor,
				"This is the [b]Radar screen[/b]",
				{
					fontFamily: "Space Grotesk",
					fontSize: scene.fontSize - 8 * scene.scaleFactor,
					color: "#11044E",
					align: "center",
					//lineSpacing: 6,
					resolution: 2,
				},
			).setDepth(2).setOrigin(0.5)

			overlay.setAboveOverlay([nextButton, nextText, scene.tutorialHand, radarTip, radarText]);

			nextButton.on("pointerdown", () => {
				playUISound(scene, scene.soundManager, "Subtle click 1", 0.25)
				nextButton.destroy()
				nextText.destroy()
				radarTip.destroy()
				radarText.destroy()
				destroyTutorialHand(scene)
				overlay.remove()
				step04(scene)
			})

			animateElements([radarTip, radarText, nextButton, nextText], scene)
		}

		function step04(scene) {
			scene.tutorialStep = 5

			console.log("!!!!!!!!!!!!!Current Tut Step = " + scene.tutorialStep)
			const overlay = phaserOverlay(scene);

			const button = scene.frontButton

			overlay.setTargetByCoords(
				button.x - (button.width * scene.scaleFactor * 0.35 / 2),
				button.y - (button.height * scene.scaleFactor * 0.35 / 2),
				button.width * scene.scaleFactor * 0.35,
				button.height * scene.scaleFactor * 0.35,
				15
			)

			displayTutorialHand(scene, {
				xPos: scene.frontButton.x - 70 * scene.scaleFactor,
				yPos: scene.frontButton.y - 1 * scene.scaleFactor,
				rotation: 90
			})

			let tutorialTip = scene.add.image(scene.frontButton.x, scene.frontButton.y - 100 * scene.scaleFactor, "tutorialPressRight").setScale(scene.scaleFactor * 0.5)
			let tutorialText = scene.add.rexBBCodeText(
				// tutorialTip.x - 85 * scene.scaleFactor,
				// tutorialTip.y - 25 * scene.scaleFactor,
				tutorialTip.x,
				tutorialTip.y - 10 * scene.scaleFactor,
				"This button allows you\nto [b]move to the right,[/b]\nto see more of the spaceship\n[b]Press it![/b]",
				{
					fontFamily: "Space Grotesk",
					fontSize: scene.fontSize - 8 * scene.scaleFactor,
					color: "#11044E",
					align: "center",
					//lineSpacing: 6,
					resolution: 2,
				},
			).setDepth(2).setOrigin(0.5)

			scene.frontButton.setAlpha(1)
			overlay.setAboveOverlay([scene.frontButton, scene.tutorialHand, tutorialTip, tutorialText]);

			animateElements([tutorialTip, tutorialText, scene.tutorialHand], scene)

			//references
			scene.step04Overlay = overlay
			scene.step04Tip = tutorialTip
			scene.step04TipText = tutorialText
		}

		function step05(scene) {
			// scene.step04Overlay.remove()
			// scene.step04Tip.destroy()
			// scene.step04TipText.destroy()

			//scene.tutorialStep = 6
			const overlay = phaserOverlay(scene);

			overlay.setTargetByCoords(
				scene.gameW / 2 - scene.leftTubeFront.width * scene.scaleFactor * 0.8 / 2,
				scene.gameH / 2 - scene.leftTubeFront.height * scene.scaleFactor * 0.8 / 2,
				scene.leftTubeFront.width * scene.scaleFactor * 0.8,
				scene.leftTubeFront.height * scene.scaleFactor * 0.8,
				15
			)

			let nextButton = scene.add.image(scene.gameW / 2, scene.gameH - 60 * scene.scaleFactor, "normalWideBtn").setScale(scene.scaleFactor * 0.5).setInteractive()
			nextButton.setInteractive()
			let nextText = scene.add.text(nextButton.x, nextButton.y - 5 * scene.scaleFactor, "NEXT", {
				fontSize: Math.round(scene.fontSize + 11 * scene.scaleFactor) + "px",
				fill: "#FFFFFF",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			})
				.setOrigin(0.5)
				.setDepth(2)

			displayTutorialHand(scene, {
				xPos: nextButton.x + 110 * scene.scaleFactor,
				yPos: nextButton.y - 50 * scene.scaleFactor,
				rotation: -120
			})

			let tutorialTip = scene.add.image(
				scene.gameW / 2,
				scene.leftTubeFront.y - scene.leftTubeFront.height * scene.scaleFactor * 0.5 + 20 * scene.scaleFactor,
				"tutorialTip")
				.setScale(scene.scaleFactor * 0.6)
			let tutorialText = scene.add.rexBBCodeText(
				// tutorialTip.x - 85 * scene.scaleFactor,
				// tutorialTip.y - 25 * scene.scaleFactor,
				tutorialTip.x,
				tutorialTip.y - 10 * scene.scaleFactor,
				"This is [b]tube 1[/b]\nYou will care for a creature here",
				{
					fontFamily: "Space Grotesk",
					fontSize: scene.fontSize - 8 * scene.scaleFactor,
					color: "#11044E",
					align: "center",
					//lineSpacing: 6,
					resolution: 2,
				},
			).setDepth(2).setOrigin(0.5)

			overlay.setAboveOverlay([scene.tutorialHand, tutorialTip, tutorialText, nextButton, nextText]);

			scene.frontButton.setAlpha(0.5)
			overlay.setBelowOverlay([scene.frontButton])

			animateElements([tutorialTip, tutorialText, nextButton, nextText], scene)

			nextButton.on("pointerdown", () => {
				playUISound(scene, scene.soundManager, "Subtle click 1", 0.25)
				nextButton.destroy()
				nextText.destroy()
				tutorialTip.destroy()
				tutorialText.destroy()
				destroyTutorialHand(scene)
				overlay.remove()
				step06(scene)
				scene.tutorialStep = 6
			})
		}

		function step06(scene) {
			const overlay = phaserOverlay(scene);

			const button = scene.backButton

			overlay.setTargetByCoords(
				button.x - (button.width * scene.scaleFactor * 0.35 / 2),
				button.y - (button.height * scene.scaleFactor * 0.35 / 2),
				button.width * scene.scaleFactor * 0.35,
				button.height * scene.scaleFactor * 0.35,
				15
			)

			displayTutorialHand(scene, {
				xPos: scene.backButton.x + 70 * scene.scaleFactor,
				yPos: scene.backButton.y - 10 * scene.scaleFactor,
				rotation: -90
			})

			let tutorialTip = scene.add.image(scene.backButton.x, scene.backButton.y - 100 * scene.scaleFactor, "leftButtonTip").setScale(scene.scaleFactor * 0.6)
			let tutorialText = scene.add.rexBBCodeText(
				tutorialTip.x,
				tutorialTip.y - 10 * scene.scaleFactor,
				"This button allows you to [b]move to the left\nPress it[/b] to go back to the cockpit!",
				{
					fontFamily: "Space Grotesk",
					fontSize: scene.fontSize - 8 * scene.scaleFactor,
					color: "#11044E",
					align: "center",
					//lineSpacing: 6,
					resolution: 2,
				},
			).setDepth(2).setOrigin(0.5)

			scene.backButton.setAlpha(1)

			overlay.setAboveOverlay([scene.backButton, scene.tutorialHand, tutorialTip, tutorialText]);

			animateElements([tutorialTip, tutorialText, scene.tutorialHand], scene)

			//references
			scene.step06Overlay = overlay
			scene.step06Tip = tutorialTip
			scene.step06TipText = tutorialText
		}

		function step07(scene) {

			scene.frontButton.setVisible(false)
			scene.backButton.setVisible(false)
			scene.tabletButton.setVisible(false)

			const overlay = phaserOverlay(scene);

			overlay.setTargetByCoords(
				-100 * scene.scaleFactor,
				-100 * scene.scaleFactor,
				25 * scene.scaleFactor,
				25 * scene.scaleFactor,
				15
			)

			let nextButton = scene.add.image(scene.gameW / 2, scene.gameH - 60 * scene.scaleFactor, "normalWideBtn").setScale(scene.scaleFactor * 0.5).setInteractive()
			nextButton.setInteractive()
			let nextText = scene.add.text(nextButton.x, nextButton.y - 5 * scene.scaleFactor, "FINISH", {
				fontSize: Math.round(scene.fontSize + 11 * scene.scaleFactor) + "px",
				fill: "#FFFFFF",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			})
				.setOrigin(0.5)
				.setDepth(2)

			displayTutorialHand(scene, {
				xPos: nextButton.x + 110 * scene.scaleFactor,
				yPos: nextButton.y - 50 * scene.scaleFactor,
				rotation: -120
			})

			let welcomeTip = scene.add.image(scene.gameW / 2, scene.gameH / 2, "welcomeTip").setScale(scene.scaleFactor * 0.6).setDepth(2)
			let welcomeText = scene.add.rexBBCodeText(
				// scene.gameW / 2 - 130 * scene.scaleFactor,
				// scene.gameH / 2 - 18 * scene.scaleFactor,
				welcomeTip.x,
				welcomeTip.y,
				"Now you know your way around!\nPress [b]‘FINISH'[/b] to complete the tutorial",
				{
					fontFamily: "Space Grotesk",
					fontSize: scene.fontSize - 6 * scene.scaleFactor,
					color: "#11044E",
					align: "center",
					//lineSpacing: 6,
					resolution: 2,
				},
			).setDepth(2).setOrigin(0.5)

			overlay.setAboveOverlay([nextButton, nextText, welcomeTip, welcomeText, scene.tutorialHand]);

			animateElements([welcomeTip, welcomeText, nextButton, nextText], scene)

			overlay.setBelowOverlay([scene.backButton])

			nextButton.on("pointerdown", () => {
				playUISound(scene, scene.soundManager, "Subtle click 1", 0.25)
				nextButton.destroy()
				nextText.destroy()
				welcomeTip.destroy()
				welcomeText.destroy()
				destroyTutorialHand(scene)
				step08(scene)
				overlay.remove()
			})

			scene.tutorialComplete = true
		}

		function step08(scene) {
			let container = scene.add.image(scene.gameW / 2, scene.gameH / 2, "basicContainer").setScale(scene.scaleFactor * 0.5)
			let contaiinerTitle = scene.add.text(
				container.x,
				container.y - 65 * scene.scaleFactor,
				"Welcome to Planet Hypotherra",
				{
					fontSize: Math.round(scene.fontSize + 2 * scene.scaleFactor) + "px",
					fill: "#11044E",
					align: "center",
					fontFamily: '"Gluten", sans-serif',
					fontStyle: "bold",
					fontWeight: "700",
					resolution: 2,
				}
			).setOrigin(0.5)
			let containerText = scene.add.rexBBCodeText(
				container.x,
				container.y - 15 * scene.scaleFactor,
				"[b]2 Creatures[/b] need your help!\n\nPress the [b]‘OK’ button[/b] to get started",
				{
					fontFamily: "Space Grotesk",
					fontSize: scene.fontSize - 4 * scene.scaleFactor,
					color: "#11044E",
					align: "center",
					lineSpacing: 4,
					resolution: 2,
				},
			).setOrigin(0.5)

			let startButton = scene.add.image(container.x, container.y + 65 * scene.scaleFactor, "okBtn_").setScale(scene.scaleFactor * 0.5).setInteractive()
			let startText = scene.add.text(startButton.x, startButton.y - 5 * scene.scaleFactor, "OK", {
				fontSize: Math.round(scene.fontSize + 11 * scene.scaleFactor) + "px",
				fill: "#ffffff",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			})
				.setOrigin(0.5)

			startButton.on("pointerdown", () => {
				playUISound(scene, scene.soundManager, "Subtle click 1", 0.25)
				container.destroy()
				contaiinerTitle.destroy()
				containerText.destroy()
				startButton.destroy()
				startText.destroy()
				scene.setupTutorialMode()
			})

			animateElements([container, contaiinerTitle, containerText, startButton, startText], scene)

			scene.leftScaleUpButton.setVisible(true)
			scene.leftScaleUpButton.input.enabled = true
			scene.rightScaleUpButton.setVisible(true)
			scene.frontButton.setAlpha(1)

			let savedUserData = checkLocalSavedData()
			savedUserData.onboardingCompleted = true
			localStorage.setItem("userData", JSON.stringify(savedUserData))
		}


	}

	hideElements() {
		// Hide elements not needed in tutorial
		// this.frontButton.setVisible(false)
		// this.backButton.setVisible(false)
		// this.tabletButton.setVisible(false)
		// this.tabletButton.setAlpha(0.5)
		// this.tabletButton.input.enabled = false

		// Hide left side elements
		this.LScanButton.setVisible(false)
		this.LScanText.setVisible(false)
		this.LDischargeButton.input.enabled = false
		this.taskHeader.setVisible(false)
		this.taskHeaderText.setVisible(false)
		this.LFoodTaskHolder.setVisible(false)
		this.LTaskGrid.setVisible(false)
		this.LDischargeButton.setAlpha(0.5)
		this.LDischargeButton.setVisible(false)
		this.LDischargeText.setVisible(false)
		this.LFeedMeButton.setVisible(false)
		this.LFeedMeText.setVisible(false)

		// Hide right side elements
		this.RScanButton.setVisible(false)
		this.RScanText.setVisible(false)
		this.RDischargeButton.input.enabled = false
		this.RTaskHeader.setVisible(false)
		this.RTaskHeaderText.setVisible(false)
		this.RFoodTaskHolder.setVisible(false)
		this.RTaskGrid.setVisible(false)
		this.rightScaleUpButton.setAlpha(0.5)
		this.rightScaleUpButton.setVisible(true)
		this.rightScaleUpButton.input.enabled = false
		this.RDischargeButton.setAlpha(0.5)
		this.RDischargeButton.setVisible(false)
		this.RDischargeText.setVisible(false)
		this.RFeedMeButton.setVisible(false)
		this.RFeedMeText.setVisible(false)

		this.hideAllFoodTaskGrids("L")
		this.hideAllFoodTaskGrids("R")
	}

	setupTutorialModeStory() {
		this.radar.setVisible(false)
		// Standard button sizing and spacing
		this.buttonWidth = 50
		this.buttonHeight = 50

		// Reset to first page when scene initializes
		this.currentPage = 0

		// Define story content for each page
		this.storyTitles = ["[b]Touchdown complete![/b]", ""]

		if (this.currentPlanet === 1) {
			this.storyExplanations = [
				"Welcome, Medinaut! You’ve successfully landed on [b]Hypotherra:[/b] a chilly world teeming with creatures in need of care.\n\nPress the [b]NEXT ARROW[/b] button below to find out what’s next.",
				"Our scanners have picked up [b]two lifeforms[/b] nearby that need your help and good food.\n\nUp next: [b]Activate the ship’s radar system[/b] to track them down and bring them aboard.",
			]
		}
		this.welcomeToPlanetPanel()
		//yOffset is the buttons
		// this.storyPanel = createStoryPanel(this, {
		// 	xScale: 1,
		// 	yScale: 1,
		// 	titles: this.storyTitles,
		// 	content: this.storyExplanations,
		// 	nextSceneKey: null,
		// 	buttonWidth: this.buttonWidth,
		// 	buttonHeight: this.buttonHeight,
		// 	fontSize: this.fontSize,
		// 	finalButtonText: "LET'S GO!",
		// 	indicatorYOffset: 230,
		// 	yOffset: 60,
		// 	titleXPos: 250,
		// 	titleYPos: 80,
		// 	titleFontScale: 5,
		// 	contentFontScale: -6,
		// 	contentYOffset: -20,
		// 	wrapWidth: 0.6,
		// })

		// const overlay = htmlOverlay(scene);
		// const button = this.scanButton; // Your Phaser game object
		// overlay.setTargetByCoords(
		// 	button.x - button.width / 2,
		// 	button.y - button.height / 2,
		// 	button.width,
		// 	button.height
		// );

		//////////////////////////////////////////////////////////////

		// Hide elements not needed in tutorial
		this.frontButton.setVisible(false)
		this.backButton.setVisible(false)
		this.tabletButton.setVisible(false)
		this.tabletButton.setAlpha(0.5)
		this.tabletButton.input.enabled = false

		// Hide left side elements
		this.LScanButton.setVisible(false)
		this.LScanText.setVisible(false)
		this.LDischargeButton.input.enabled = false
		this.taskHeader.setVisible(false)
		this.taskHeaderText.setVisible(false)
		this.LFoodTaskHolder.setVisible(false)
		this.LTaskGrid.setVisible(false)
		this.LDischargeButton.setAlpha(0.5)
		this.LDischargeButton.setVisible(false)
		this.LDischargeText.setVisible(false)
		this.LFeedMeButton.setVisible(false)
		this.LFeedMeText.setVisible(false)

		// Hide right side elements
		this.RScanButton.setVisible(false)
		this.RScanText.setVisible(false)
		this.RDischargeButton.input.enabled = false
		this.RTaskHeader.setVisible(false)
		this.RTaskHeaderText.setVisible(false)
		this.RFoodTaskHolder.setVisible(false)
		this.RTaskGrid.setVisible(false)
		this.rightScaleUpButton.setAlpha(0.5)
		this.rightScaleUpButton.setVisible(true)
		this.rightScaleUpButton.input.enabled = false
		this.RDischargeButton.setAlpha(0.5)
		this.RDischargeButton.setVisible(false)
		this.RDischargeText.setVisible(false)
		this.RFeedMeButton.setVisible(false)
		this.RFeedMeText.setVisible(false)

		this.hideAllFoodTaskGrids("L")
		this.hideAllFoodTaskGrids("R")
	}

	setupTutorialMode() {
		this.radar.setVisible(true)
		// Show instructions
		displayInstructions(
			this,
			"Press the radar screen to find the creatures",
			15,
			400,
			60,
		)
		//scene, xpos, ypos, width, height
		displayIndicator(
			this,
			this.radar.x + 1 * this.scaleFactor,
			this.radar.y + 10 * this.scaleFactor,
			1,
			"radarIndicator",
		)

		displayTutorialHand(this, {
			xPos: this.radar.x - 100 * this.scaleFactor,
			yPos: this.radar.y + 100 * this.scaleFactor,
			rotation: 45
		})

		const isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent,
			)

		let yOffset
		let fontScale
		let wordWrap = 1.01
		if (isMobile) {
			yOffset = 9
			fontScale = -7
		} else {
			yOffset = 6
			fontScale = -9
			wordWrap = 1.01
		}

		displayTooltip(this, {
			xPos: this.radar.x,
			yPos: this.radar.y + 120 * this.scaleFactor,
			type: "pressMeTip",
			scale: 1.5,
			text: "press the\nscreen!",
			fontScale: fontScale,
			xTextOffset: 1,
			yTextOffset: yOffset,
			wrapWidth: wordWrap,
		})
	}

	setupNormalMode() {

		// this.showLaunchButton()
		// return
		console.log(
			"Normal Mode Current Planet: " +
			this.currentPlanet +
			"Mini Level: " +
			this.savedMiniLevel,
		)
		this.radar.setVisible(false)
		// Standard button sizing and spacing
		this.buttonWidth = 50
		this.buttonHeight = 50

		// Reset to first page when scene initializes
		this.currentPage = 0

		// Define story content for each page
		this.storyTitles = ["[b]Touchdown complete![/b]", ""]

		if (this.currentPlanet === 2) {
			this.storyExplanations = [
				"Welcome, Medinaut! You’ve landed on [b]Stratosoma:[/b] a wispy world of floating cliffs and drifting mists.\n\n\nPress the [b]NEXT ARROW[/b] button below to find out what’s next.",
				"Our scanners show [b]three creatures[/b] in the area needing care.\n\nGet ready to [b]fire up the radar[/b] and beam them aboard! Time to work your Medinaut magic in the clouds!",
			]
		} else if (this.currentPlanet === 3) {
			this.storyExplanations = [
				"Greetings, Medinaut! Welcome to [b]Emberon:[/b] a scorched, glowing landscape of heat and magma. Press the [b]NEXT ARROW[/b] button below to find out what’s next.",
				"Our systems have detected [b]three lifeforms[/b] nearby that need urgent care and attention. [b]Activate your radar[/b] and bring them aboard before things get too toasty. Let’s cool things down with some top-notch Medinaut TLC!",
			]
		}

		// this.storyPanel = createStoryPanel(this, {
		// 	xScale: 1,
		// 	yScale: 1,
		// 	titles: this.storyTitles,
		// 	content: this.storyExplanations,
		// 	nextSceneKey: null,
		// 	buttonWidth: this.buttonWidth,
		// 	buttonHeight: this.buttonHeight,
		// 	fontSize: 20,
		// 	finalButtonText: "LET'S GO!",
		// 	indicatorYOffset: 230,
		// 	yOffset: 60,
		// 	titleXPos: 250,
		// 	titleYPos: 80,
		// 	titleFontScale: 5,
		// 	contentFontScale: -6,
		// 	contentYOffset: -20,
		// 	wrapWidth: 0.6,
		// })

		this.welcomeToPlanetPanel()

		//this.creature3Panel()


		// Hide elements not needed in tutorial
		this.frontButton.setVisible(false)
		this.backButton.setVisible(false)
		this.tabletButton.setAlpha(0.5)
		this.tabletButton.input.enabled = false

		// Hide left side elements
		this.LScanButton.setVisible(false)
		this.LScanText.setVisible(false)
		this.LDischargeButton.setVisible(false)
		this.LDischargeText.setVisible(false)
		this.LDischargeButton.input.enabled = false
		this.LDischargeText.setVisible(false)
		this.taskHeaderText.setVisible(false)
		this.taskHeader.setVisible(false)

		// Hide all left food task grids - now handling multiple food grids
		this.hideAllFoodTaskGrids("L")

		this.LTaskGrid.setVisible(false)
		this.LDischargeButton.setAlpha(0.5)
		this.LFeedMeButton.setVisible(false)
		this.LFeedMeText.setVisible(false)

		// Hide right side elements
		this.RScanButton.setVisible(false)
		this.RScanText.setVisible(false)
		this.RDischargeButton.setVisible(false)
		this.RDischargeText.setVisible(false)
		this.RDischargeText.setVisible(false)
		this.RDischargeButton.input.enabled = false
		this.RTaskHeaderText.setVisible(false)
		this.RTaskHeader.setVisible(false)

		// Hide all right food task grids - now handling multiple food grids
		this.hideAllFoodTaskGrids("R")

		this.RTaskGrid.setVisible(false)
		this.rightScaleUpButton.setAlpha(0.5)
		this.rightScaleUpButton.input.enabled = false
		this.RDischargeButton.setAlpha(0.5)
		this.RFeedMeButton.setVisible(false)
		this.RFeedMeText.setVisible(false)
	}

	// Helper method to hide all food task grids for a given side
	hideAllFoodTaskGrids(prefix) {
		let foundAny = false

		// First check if the old single-grid format exists and hide it
		if (this[`${prefix}FoodTaskGrid`]) {
			this[`${prefix}FoodTaskGrid`].setVisible(false)
			foundAny = true
		}

		// Then try to hide the indexed food grids
		let gridIndex = 0
		let gridName = `${prefix}FoodTaskGrid_${gridIndex}`

		// Keep looking for food grids with incrementing indices
		while (this[gridName]) {
			this[gridName].setVisible(false)
			foundAny = true
			gridIndex++
			gridName = `${prefix}FoodTaskGrid_${gridIndex}`
		}

		this.taskHeader.setVisible(false)
		this.RTaskHeader.setVisible(false)

		if (this.taskHeader02) this.taskHeader02.setVisible(false)
		if (this.foodLabel) this.foodLabel.setVisible(false)

		if (!foundAny) {
			console.log(`No food task grids found for prefix: ${prefix}`)
		}
	}

	//Helper method to show all food task grids for a given side
	showAllFoodTaskGrids(prefix) {
		// Try to show the indexed food grids first
		let gridIndex = 0
		let gridName = `${prefix}FoodTaskGrid_${gridIndex}`
		let foundAny = false

		// Keep looking for food grids with incrementing indices
		while (this[gridName]) {
			this[gridName].setVisible(true)
			foundAny = true
			gridIndex++
			gridName = `${prefix}FoodTaskGrid_${gridIndex}`
		}

		// As a fallback, try to show the old single-grid format
		if (!foundAny && this[`${prefix}FoodTaskGrid`]) {
			this[`${prefix}FoodTaskGrid`].setVisible(true)
		}

		// Hide the second food task grid
		const secondFoodGrid = this[`${prefix}FoodTaskGrid_1`]
		if (secondFoodGrid) {
			secondFoodGrid.setVisible(false)
		}

		console.log("Show all food task grids for " + prefix)
	}

	//Helper method to show all food task grids for a given side to feed
	showAllFoodTaskGridsFeeding(prefix) {
		const isLeft = prefix === "L"

		const currentCreature = isLeft
			? this.currentLeftCreature
			: this.currentRightCreature

		// Get creature data from JSON
		this.creatureData = this.cache.json.get("creatureData")
		const creature = this.creatureData.creatures.find(
			({ index }) => index === currentCreature,
		)
		console.log("current CREATURE " + currentCreature)

		// Check how many food types this creature eats
		const foodTypes = creature.food || []
		const foodAmounts = creature.foodAmount || []

		if (isLeft) {
			console.log("L Food Types: " + foodTypes)
			console.log("L Food Amounts: " + foodAmounts)
		} else {
			console.log("R Food Types: " + foodTypes)
			console.log("R Food Amounts: " + foodAmounts)
		}

		// Try to show the indexed food grids first
		let gridIndex = 0
		let gridName = `${prefix}FoodTaskGrid_${gridIndex}`
		let foundAny = false

		// Keep looking for food grids with incrementing indices
		while (this[gridName]) {
			this[gridName].setVisible(true)
			console.log(
				`Showing ${gridName} for ${prefix} with food type: ${foodTypes[gridIndex]}`,
			)
			const gridItems = this[gridName].getChildren()
			const amount = foodAmounts[gridIndex]
			for (let i = 0; i < gridItems.length; i++) {
				if (i < amount) {
					gridItems[i].setVisible(true)
				} else {
					gridItems[i].setVisible(false)
				}
			}

			foundAny = true
			gridIndex++
			gridName = `${prefix}FoodTaskGrid_${gridIndex}`
		}

		// As a fallback, try to show the old single-grid format
		if (!foundAny && this[`${prefix}FoodTaskGrid`]) {
			this[`${prefix}FoodTaskGrid`].setVisible(true)
		}

		if (prefix === "L") {
			if (this.foodLabel) {
				this.foodLabel.setVisible(true)
				this.taskHeader02.setVisible(true)
				this.foodLabel.setText(foodTypes[1])
				console.log("this.taskHeader02 EXISTS")
			}
		}

		console.log("Show all feeding food task grids for " + prefix)
		this.loadSavedData()
		if (this.currentPlanet === 3 && this.savedMiniLevel >= 18) {
			this.taskHeader02.setVisible(false)

			this.taskHeader02BackUp = this.add
				.image(
					240 * this.scaleFactor,
					this.taskHeader02OriginalPosition.y,
					"taskHeader",
				)
				.setOrigin(0.5)
				.setScale(this.scaleFactor, this.scaleFactor)
				.setName(`TaskHeader02BU`)

			console.log("SHowing BACKUPHEADEr02")
		}

		// this.taskHeader02BackUp = this.add
		// 	.image(
		// 		240 * this.scaleFactor,
		// 		this.taskHeader02OriginalPosition.y,
		// 		"taskHeader",
		// 	)
		// 	.setOrigin(0.5)
		// 	.setScale(this.scaleFactor, this.scaleFactor)
		// 	.setName(`TaskHeader02BU`)
		// 	//.setTint(0xf3f)

		// console.log("SHowing BACKUPHEADEr02")
	}

	setupNormalMode02() {
		if (this.currentPlanet === 1) {
			this.setupTutorialMode()
			return
		}

		this.radar.setVisible(true)
		// Show instructions
		displayInstructions(
			this,
			"Press the radar screen to find the creatures",
			15,
			400,
			60,
		)

		if (this.currentPlanet === 2) {
			//scene, xpos, ypos, width, height
			displayIndicator(
				this,
				this.radar.x + 1 * this.scaleFactor,
				this.radar.y + 10 * this.scaleFactor,
				1,
				"radarIndicator",
			)

			displayTutorialHand(this, {
				xPos: this.radar.x - 100 * this.scaleFactor,
				yPos: this.radar.y + 100 * this.scaleFactor,
				rotation: 45
			})
		}

		const isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent,
			)

		let yOffset
		let fontScale
		let wordWrap = 1.01
		if (isMobile) {
			yOffset = 9
			fontScale = -7
		} else {
			yOffset = 6
			fontScale = -9
			wordWrap = 1.01
		}

		// displayTooltip(this, {
		// 	xPos: this.radar.x,
		// 	yPos: this.radar.y + 120 * this.scaleFactor,
		// 	type: "pressMeTip",
		// 	scale: 1.65,
		// 	text: "[b]press[/b] the screen",
		// 	fontScale: fontScale,
		// 	xTextOffset: 1,
		// 	yTextOffset: yOffset,
		// 	wrapWidth: wordWrap,
		// })

		console.log("Normal 2")
	}

	cockpitSoundHandler(sound) {
		playUISound(this, this.soundManager, sound, 0.25)
	}

	pauseAllSounds() {
		// Pause cockpit music
		this.soundManager.pauseMusic("Muzac_bad_speaker")

		// Pause landing ambiance
		if (this.scene.isActive("landingScene")) {
			const landingScene = this.scene.get("landingScene")
			if (landingScene.ambianceSound && !landingScene.ambianceSound.paused) {
				landingScene.ambianceSound.pause()
			}
		}

		// Additional safety: pause all sounds in this scene
		this.sound.pauseAll()
	}

	displayOverlay() {
		const overlay = phaserOverlay(this);

		const button = this.tabletButton

		overlay.setTargetByCoords(
			this.tabletButton.x - 55 * this.scaleFactor,
			this.tabletButton.y - 55 * this.scaleFactor,
			button.width * this.scaleFactor * 0.5,
			button.height * this.scaleFactor * 0.5,
			15
		)

		this.tabletOverlayReference = overlay

		overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.tutorialHand, this.instructionBgContainer, this.instructionBgCenter, this.instructionBgRight, this.instructionText]);
	}

	displayFeedOverlay() {
		const overlay = phaserOverlay(this)
		overlay.setTargetByCoords(
			this.gameW / 2 - this.LFeedMeButton.width * this.scaleFactor * 0.25,
			this.gameH / 2 - this.LFeedMeButton.height * this.scaleFactor * 0.25 - 4 * this.scaleFactor,
			this.LFeedMeButton.width * this.scaleFactor * 0.5,
			this.LFeedMeButton.height * this.scaleFactor * 0.5,
		)

		displayTutorialHand(this, {
			xPos: this.gameW / 2 + 60 * this.scaleFactor,
			yPos: this.gameH / 2 - 50 * this.scaleFactor,
			rotation: -120
		})

		overlay.setAboveOverlay([this.tutorialHand, this.instructionBgContainer, this.instructionBgCenter, this.instructionBgRight, this.instructionText])

		this.feedOverlayRef = overlay
	}

	displayDischargeOverlay() {

		displayTutorialHand(this, {
			xPos:
				this.LDischargeButton.x -
				this.gameW -
				105 * this.scaleFactor,
			yPos: this.LDischargeButton.y - 70 * this.scaleFactor,
			rotation: 135,
		})

		const overlay = phaserOverlay(this);

		const button = this.LDischargeButton

		overlay.setTargetByCoords(
			this.gameW / 2 + 100 * this.scaleFactor,
			this.LDischargeButton.y - button.height * this.scaleFactor * 0.5 - 7 * this.scaleFactor,
			button.width * this.scaleFactor,
			button.height * this.scaleFactor,
			15
		)
		this.dischargeOverlayRef = overlay

		overlay.setAboveOverlay([this.instructionBgContainer, this.instructionBgCenter, this.instructionBgRight, this.instructionText, this.tooltip, this.tooltipText, this.tutorialHand])


	}

	displayReturnOverlay() {
		console.log("ReturnOverlay!!!!!!!!!!!!!!!!!")

		if (this.tutorialHand) {
			this.tutorialHand.destroy()
		}
		const overlay = phaserOverlay(this);

		const button = this.leftScaleUpButton

		overlay.setTargetByCoords(
			15 * this.scaleFactor,
			8 * this.scaleFactor,
			button.width * this.scaleFactor * 0.55,
			button.height * this.scaleFactor * 0.5,
			15
		)
		this.zoomOutOverlay = overlay

		overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.instructionBgContainer, this.instructionBgCenter, this.instructionBgRight, this.instructionText])
	}

	newMissionCompletePanel() {

		const depth = 10
		const creaturesNumber = this.currentPlanet === 1 ? 2 : 3;
		let container = this.add.image(this.gameW / 2, this.gameH / 2, "basicContainer").setScale(this.scaleFactor * 0.5).setDepth(depth)
		let contaiinerTitle = this.add.text(
			container.x,
			container.y - 65 * this.scaleFactor,
			"Mission Complete!",
			{
				fontSize: Math.round(this.fontSize + 2 * this.scaleFactor) + "px",
				fill: "#11044E",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			}
		).setOrigin(0.5).setDepth(depth)
		let containerText = this.add.rexBBCodeText(
			container.x,
			container.y - 15 * this.scaleFactor,
			`You've cared for [b]${creaturesNumber} Creatures[/b] and earned enough [b]fuel[/b]\nOnto the next planet!`,
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 4 * this.scaleFactor,
				color: "#11044E",
				align: "center",
				lineSpacing: 4,
				resolution: 2,
			},
		).setOrigin(0.5).setDepth(depth)

		if (this.currentPlanet === 3) {
			containerText.setText(`You've cared for [b]${creaturesNumber} Creatures[/b] and earned enough [b]fuel[/b]\nTime for liftoff!`)
		}

		let toTheCockpitBtn = this.add.image(
			container.x,
			container.y + 50 * this.scaleFactor,
			"toTheCockpitBtn")
			.setScale(this.scaleFactor * 0.5)
			.setInteractive().setDepth(depth)

		let toTheCockpitText = this.add.text(
			toTheCockpitBtn.x,
			toTheCockpitBtn.y - 7 * this.scaleFactor,
			"TO THE COCKPIT!", {
			fontSize: Math.round(this.fontSize - 1 * this.scaleFactor) + "px",
			fill: "#FFFFFF",
			align: "center",
			fontFamily: '"Gluten", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})
			.setOrigin(0.5)
			.setDepth(depth)

		animateElements([container, contaiinerTitle, containerText, toTheCockpitBtn, toTheCockpitText], this)

		if (this.notificationBell) {
			this.notificationBell.destroy()
		}
		// toTheCockpitBtn.on("pointerup", () => {
		// 	console.log("Current Page: " + this.currentPage);
		// 	if (this.currentPage != 0) {
		// 		const direction = 1;
		// 		const steps = Math.abs(this.currentPage - 0);

		// 		for (let i = 0; i < this.currentPage; i++) {
		// 			this.moveCockpit(direction);
		// 		}
		// 	}
		// });

		toTheCockpitBtn.on("pointerup", async () => {
			toTheCockpitBtn.setAlpha(0.5);
			toTheCockpitBtn.input.enabled = false;
			console.log("Current Page: " + this.currentPage);

			if (this.currentPage != 0) {
				let direction;
				let steps;

				// Determine the shortest path to page 0
				if (this.currentPage === 1) {
					// Go left 1 step: 1 -> 0
					direction = 1;
					steps = 1;
				} else if (this.currentPage === 2) {
					// Go left 2 steps: 2 -> 1 -> 0
					direction = -1;
					steps = 2;
				} else if (this.currentPage === 3) {
					// Go right 1 step: 3 -> 0 (wrapping around)
					direction = -1;
					steps = 1;
				}

				for (let i = 0; i < steps; i++) {
					this.moveCockpit(direction);
					if (i < steps - 1) { // Don't wait after the last move
						await new Promise(resolve => setTimeout(resolve, 1250));
					}
				}

				container.destroy();
				contaiinerTitle.destroy();
				containerText.destroy();
				toTheCockpitBtn.destroy();
				toTheCockpitText.destroy();
				destroyFireworksAnimation(this);

				if (this.currentPlanet === 3) {
					this.disableNavigationButtons()
					//this.showLaunchButton()

					displayInstructions(
						this,
						"Press the button to go!",
						12,
						300,
						55,
					)

					this.handleMissionComplete()

				}
			}
		});

		playFireworksAnimation(this, {
			width: container.width * this.scaleFactor * 0.5,
			height: container.height * this.scaleFactor * 0.5,
			duration: Infinity,
			depth: depth - 1
		})
	}

	creature3Panel() {
		destroyInstructions(this)
		this.removeNotification()
		let container = this.add.image(this.gameW / 2, this.gameH / 2, "basicContainer").setScale(this.scaleFactor * 0.5)
		let contaiinerTitle = this.add.text(
			container.x,
			container.y - 65 * this.scaleFactor,
			"Creature 3 is Loaded!",
			{
				fontSize: Math.round(this.fontSize + 2 * this.scaleFactor) + "px",
				fill: "#11044E",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			}
		).setOrigin(0.5)
		let containerText = this.add.rexBBCodeText(
			container.x,
			container.y - 35 * this.scaleFactor,
			"It is ready to be treated. Go there now!",
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 4 * this.scaleFactor,
				color: "#11044E",
				align: "center",
				lineSpacing: 4,
				resolution: 2,
			},
		).setOrigin(0.5)

		let toTheCockpitBtn = this.add.image(
			container.x,
			container.y + 50 * this.scaleFactor,
			"toTheCockpitBtn")
			.setScale(this.scaleFactor * 0.6)
			.setInteractive()

		let toTheCockpitText = this.add.text(
			toTheCockpitBtn.x,
			toTheCockpitBtn.y - 7 * this.scaleFactor,
			"GO TO THIRD CREATURE!", {
			fontSize: Math.round(this.fontSize - 1 * this.scaleFactor) + "px",
			fill: "#FFFFFF",
			align: "center",
			fontFamily: '"Gluten", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})
			.setOrigin(0.5)
			.setDepth(2)

		animateElements([container, contaiinerTitle, containerText, toTheCockpitBtn, toTheCockpitText], this)

		if (this.currentPlanet === 2) {
			displayTutorialHand(this, {
				xPos: toTheCockpitBtn.x + 175 * this.scaleFactor,
				yPos: toTheCockpitBtn.y - 50 * this.scaleFactor,
				rotation: -120
			})
		}
		toTheCockpitBtn.on("pointerup", async () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			toTheCockpitBtn.setAlpha(0.5);
			toTheCockpitBtn.input.enabled = false;

			if (this.currentPage !== 1) {
				let direction;
				let steps;

				// Determine the shortest path to page 1
				if (this.currentPage === 0) {
					// Go right 1 step: 0 -> 1
					direction = -1;
					steps = 1;
				} else if (this.currentPage === 2) {
					// Go left 1 step: 2 -> 1
					direction = 1;
					steps = 1;
				} else if (this.currentPage === 3) {
					// Go left 2 steps: 3 -> 2 -> 1
					direction = 1;
					steps = 2;
				}

				for (let i = 0; i < steps; i++) {
					this.moveCockpit(direction);
					if (i < steps - 1) {
						await new Promise(resolve => setTimeout(resolve, 1250));
					}
				}
			}

			container.destroy();
			contaiinerTitle.destroy();
			containerText.destroy();
			toTheCockpitBtn.destroy();
			toTheCockpitText.destroy();
		});
	}

	removeNotification() {
		if (this.notificationBell) {
			this.notificationBell.destroy()
		}
	}

	welcomeToPlanetPanel() {
		const planetNames = {
			2: "Stratosoma",
			3: "Emberon"
		}
		const planetName = planetNames[this.currentPlanet] || ""
		let container = this.add.image(this.gameW / 2, this.gameH / 2, "basicContainer").setScale(this.scaleFactor * 0.5)
		let contaiinerTitle = this.add.text(
			container.x,
			container.y - 65 * this.scaleFactor,
			"Welcome to Planet " + planetName,
			{
				fontSize: Math.round(this.fontSize + 2 * this.scaleFactor) + "px",
				fill: "#11044E",
				align: "center",
				fontFamily: '"Gluten", sans-serif',
				fontStyle: "bold",
				fontWeight: "700",
				resolution: 2,
			}
		).setOrigin(0.5)
		let containerText = this.add.rexBBCodeText(
			container.x,
			container.y - 15 * this.scaleFactor,
			"[b]3 Creatures[/b] need your help!\n\nPress the [b]‘OK’ button[/b] to get started",
			{
				fontFamily: "Space Grotesk",
				fontSize: this.fontSize - 4 * this.scaleFactor,
				color: "#11044E",
				align: "center",
				lineSpacing: 4,
				resolution: 2,
			},
		).setOrigin(0.5)

		let startButton = this.add.image(container.x, container.y + 65 * this.scaleFactor, "okBtn_").setScale(this.scaleFactor * 0.5).setInteractive()
		let startText = this.add.text(startButton.x, startButton.y - 5 * this.scaleFactor, "OK", {
			fontSize: Math.round(this.fontSize + 11 * this.scaleFactor) + "px",
			fill: "#ffffff",
			align: "center",
			fontFamily: '"Gluten", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})
			.setOrigin(0.5)

		startButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			container.destroy()
			contaiinerTitle.destroy()
			containerText.destroy()
			startButton.destroy()
			startText.destroy()
			this.setupNormalMode02()
		})

		animateElements([container, contaiinerTitle, containerText, startButton, startText], this)

	}
}
